import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
    musiques: [
        {
            "id": 1,
            "title": 'Le Saint-Esprit',
            "image": '',
            "author": 'Dena Mwana',
            "lyrics ": [
                {
                    "text": `Et quand l'Esprit de vérité sera venu
                    Il vous conduira dans la vérité entière
                    Car il ne parlera pas de lui-même
                    Mais tout ce qu'il aura entendu, Il le dira
                    Il vous annoncera les choses à venir
                    Il manifestera ma gloire
                    Car Il puisera ce qui est en moi et vous l'annoncera
                    Ainsi la gloire du Père se revèle par l'Esprit
                    La gloire et la Puissance de Jésus se revèle par son Esprit
                    Ainsi quelqu'un qui a cru le verra, Alléluia
                    Hmmm hmmm
                    Esprit de Dieu, nous avons besoin de toi
                    Hmmm Holy Spirit eh-eh-eh-eh-eh
                    Quand il descend
                    Oui tout s'arrête, il y a transfert entre ciel et terre
                    Quand il descend
                    L'atmosphère change, il y a transfert entre ciel
                `,
                    "ref": false
                },
                {
                    "text": "Quand il descend",
                    "ref": false
                },
                {
                    "text": "Quand il descend",
                    "ref": true
                },
                {
                    "text": "Oui tout s'arrête",
                    "ref": false
                },
                {
                    "text": "Oui tout s'arrête",
                    "ref": true
                },
                {
                    "text": "Il y a transfert entre ciel et terre",
                    "ref": false
                },
                {
                    "text": "Il y a transfert entre ciel et terre",
                    "ref": true
                },
                {
                    "text": "Quand il descend",
                    "ref": false
                },
                {
                    "text": "Quand il descend",
                    "ref": true
                },
                {
                    "text": "L'atmosphère change",
                    "ref": false
                },
                {
                    "text": "L'atmosphère change",
                    "ref": true
                },
                {
                    "text": "Il y a transfert entre ciel et terre",
                    "ref": false
                },
                {
                    "text": "Il y a transfert entre ciel et terre",
                    "ref": true
                },
                {
                    "text": "Quand il descend",
                    "ref": false
                },
                {
                    "text": "Quand il descend",
                    "ref": true
                },
                {
                    "text": "Oui tout s'arrête",
                    "ref": false
                },
                {
                    "text": "Oui tout s'arrête",
                    "ref": true
                },
                {
                    "text": "Il y a transfert entre ciel et terre",
                    "ref": false
                },
                {
                    "text": "Il y a transfert entre ciel et terre",
                    "ref": true
                },
                {
                    "text": "Quand il descend",
                    "ref": false
                },
                {
                    "text": "Quand il descend",
                    "ref": true
                },
                {
                    "text": "L'atmosphère change",
                    "ref": false
                },
                {
                    "text": "L'atmosphère change",
                    "ref": true
                },
                {
                    "text": "Il y a transfert entre ciel et terre",
                    "ref": false
                },
                {
                    "text": "Il y a transfert entre ciel et terre",
                    "ref": true
                },
                {
                    "text": "Le Saint Esprit est là ah ah",
                    "ref": false
                },
                {
                    "text": `le Saint-Esprit est là ah ah
                    Le Saint-Esprit est là ah ah
                `,
                    "ref": true
                },
                {
                    "text": "Le Saint Esprit est là, Il est là pour changer",
                    "ref": false
                },
                {
                    "text": "le Saint Esprit est là ah ah",
                    "ref": true
                },
                {
                    "text": "Il est là pour guérir, Il est là pour proclamer",
                    "ref": false
                },
                {
                    "text": "le Saint-Esprit est là ah ah",
                    "ref": true
                },
                {
                    "text": "Et voilà ce qui arrive eh",
                    "ref": false
                },
                {
                    "text": "Les maladies s'enfuient",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "les aveugles voient",
                    "ref": true
                },
                {
                    "text": "Eh-eh-eh",
                    "ref": false
                },
                {
                    "text": "les paralytiques sautent de joie",
                    "ref": true
                },
                {
                    "text": "Les stériles enfantent",
                    "ref": false
                },
                {
                    "text": "les stériles enfantent",
                    "ref": true
                },
                {
                    "text": "Les sourds entendent",
                    "ref": false
                },
                {
                    "text": "Les sourds entendent",
                    "ref": true
                },
                {
                    "text": "Par sa puissance",
                    "ref": false
                },
                {
                    "text": "par sa puissance, par sa puissance",
                    "ref": true
                },
                {
                    "text": "Les maladies",
                    "ref": false
                },
                {
                    "text": "les maladies s'enfuient",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "les aveugles voient",
                    "ref": true
                },
                {
                    "text": "Come on",
                    "ref": false
                },
                {
                    "text": "les paralytiques sautent de joie",
                    "ref": true
                },
                {
                    "text": "Ooh les stériles enfantent",
                    "ref": false
                },
                {
                    "text": "les stériles enfantent",
                    "ref": true
                },
                {
                    "text": "Les sourds entendent",
                    "ref": false
                },
                {
                    "text": "Les sourds entendent",
                    "ref": true
                },
                {
                    "text": "Par sa puissance",
                    "ref": false
                },
                {
                    "text": "par sa puissance, par sa puissance",
                    "ref": true
                },
                {
                    "text": `Souffle Esprit de Dieu, Alléluia, Alléluia eh
                    Alléluia, Alléluia eh-eh
                `,
                    "ref": false
                },
                {
                    "text": `Que Ton Esprit me sonde
                    Que Ton Esprit déborde en ce jour
                    Souffle Esprit de Dieu oh-oh-oh oh-oh-oh
                    (Souffle dans ton église) Que Ton Esprit me sonde (souffle, souffle, souffle)
                    Que Ton Esprit souffle en ce lieu Seigneur (souffle Esprit de Dieu)
                `,
                    "ref": true
                },
                {
                    "text": "Alléluia quelqu'un lui dit par sa puissance",
                    "ref": false
                },
                {
                    "text": "Par sa puissance il transforme",
                    "ref": true
                },
                {
                    "text": "Par sa puissance il guérit les malades",
                    "ref": false
                },
                {
                    "text": "par sa puissance il guérit",
                    "ref": true
                },
                {
                    "text": "Par sa puissance il renouvelle",
                    "ref": false
                },
                {
                    "text": "par sa puissance il renouvelle",
                    "ref": true
                },
                {
                    "text": "Par sa puissance il agit en ce moment",
                    "ref": false
                },
                {
                    "text": "par sa puissance il agit",
                    "ref": true
                },
                {
                    "text": "Par sa puissance",
                    "ref": false
                },
                {
                    "text": "par sa puissance",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "Il transforme",
                    "ref": true
                },
                {
                    "text": "Il transforme une situation en ce moment",
                    "ref": false
                },
                {
                    "text": "par sa puissance il guérit",
                    "ref": true
                },
                {
                    "text": "Une maladie incurable par sa puissance il renouvelle ce qui usé",
                    "ref": false
                },
                {
                    "text": "par sa puissance il renouvelle",
                    "ref": true
                },
                {
                    "text": "Par sa puissance il agit",
                    "ref": false
                },
                {
                    "text": "par sa puissance il agit",
                    "ref": true
                },
                {
                    "text": "eh-eh-eh-eh",
                    "ref": false
                },
                {
                    "text": "Come on",
                    "ref": false
                },
                {
                    "text": "les maladies s'enfuient",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": `les aveugles voient
                    Les paralytiques sautent de joie
                `,
                    "ref": true
                },
                {
                    "text": "Ah-ah-ah-ah",
                    "ref": false
                },
                {
                    "text": `les stériles enfantent
                    Les sourds entendent
                `,
                    "ref": true
                },
                {
                    "text": "les sourds entendent",
                    "ref": false
                },
                {
                    "text": "Par sa puissance, par sa puissance",
                    "ref": true
                },
                {
                    "text": "eh-eh-eh-eh",
                    "ref": false
                },
                {
                    "text": "Les maladies",
                    "ref": false
                },
                {
                    "text": "les maladies s'enfuient",
                    "ref": true
                },
                {
                    "text": "Les aveugles voient",
                    "ref": false
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "les paralytiques sautent de joie",
                    "ref": true
                },
                {
                    "text": "Et les stériles enfantent",
                    "ref": false
                },
                {
                    "text": "les stériles enfantent",
                    "ref": true
                },
                {
                    "text": "Nous le proclamons, nous le croyons",
                    "ref": false
                },
                {
                    "text": "les sourds entendent",
                    "ref": true
                },
                {
                    "text": "Par sa puissance",
                    "ref": false
                },
                {
                    "text": "par sa puissance, par sa puissance",
                    "ref": true
                },
                {
                    "text": `Quelqu'un commence à proclamer
                    Déclare les choses qui n'existent pas
                    Appelle-les à l'existence par la Puissance du Saint Esprit
                    Nous déclarons qu'il est parmi nous
                    Oh-oh, oh-oh
                    Oh-oh, oh-oh
                    Oh-oh, oh-oh (oh-oh, oh-oh)
                    Oh-oh oh-oh (oh-oh)
                    Oh-oh
                    Oh-oh, oh-oh
                    Oh-oh, oh-oh
                    Oh-oh, oh-oh
                    Oh-oh, oh-oh
                    Oh-oh, oh-oh
                    Oh-oh, oh-oh
                    Oh-oh, oh-oh
                    Oh-oh, oh-oh
                `,
                    "ref": false
                }
            ]
        },
        {
            "id": 2,
            "title": "Relâche ta gloire",
            "image": "",
            "author": "version Jean Jean",
            "lyrics": [
                {
                    "text": `Relâche ta gloire, nous voulons Te voir
                    Nous avons soif, soif, de Toi
                    Révèle-Toi, fais entendre Ta voix
                    Relâche, Ta gloire…
                    Seigneur ouvre les écluses des cieux
                    Relâche ta gloire, Relâche ta gloire
                    Seigneur ouvre les écluses des cieux
                    Relâche ta gloire, Relâche ta gloire
                    Seigneur ouvre les écluses des cieux
                    Relâche ta gloire, Relâche ta gloire
                `,
                    "ref": false
                },
                {
                    "text": `Seigneur ouvre les écluses des cieux
                    Relâche ta gloire, Relâche ta gloire
                    Seigneur ouvre les écluses des cieux
                    Relâche ta gloire, Relâche ta gloire
                    Relâche ta gloire,
                    Nous voulons te voir
                    Nous avons soif de toi
                    Révèle-toi
                    Fait entendre ta voix
                    Relâche ta gloire
                `,
                    "ref": true
                },
                {
                    "text": `Relâche ta gloire
                    Nous voulons te voir
                    Nous avons soif de toi
                    Révèle-toi
                    Fait entendre ta voix
                    Relâche ta gloire
                `,
                    "ref": true
                },
                {
                    "text": `Seigneur ouvre les écluses des cieux
                    Relâche ta gloire, Relâche ta gloire
                    Seigneur ouvre les écluses des cieux
                    Relâche ta gloire, Relâche ta gloire
                `,
                    "ref": false
                },
                {
                    "text": `Seigneur ouvre les écluses des cieux
                    Relâche ta gloire, Relâche ta gloire
                    Seigneur ouvre les écluses des cieux
                    Relâche ta gloire, Relâche ta gloire
                `,
                    "ref": true
                },
                {
                    "text": `Relâche ta gloire
                    Nous voulons te voir
                    Nous avons soif de toi
                    Révèle-toi
                    Fait entendre ta voix
                    Relâche ta gloire
                `,
                    "ref": true
                },
                {
                    "text": `Relâche ta gloire
                    Nous voulons te voir
                    Nous avons soif de toi
                    Révèle-toi
                    Fait entendre ta voix
                    Relâche ta gloire
                `,
                    "ref": true
                },
                {
                    "text": `Nous voulons te voir
                    Nous avons soif de toi
                    Révèle-toi
                    Fait entendre ta voix
                    Relâche ta gloire
                `,
                    "ref": true
                },
                {
                    "text": `Relâche les miracles
                    Relâche les prodigues
                    Relâche les anges
                    Relâche
                    Nous voulons voir ta gloire
                `,
                    "ref": true
                },
                {
                    "text": `Relâche les miracles
                    Relâche les prodigues
                    Relâche les anges
                    Relâche
                    Nous voulons voir ta gloire
                `,
                    "ref": true
                },
                {
                    "text": `Relâche les miracles
                    Relâche les prodigues
                    Relâche les anges
                    Relâche
                    Nous voulons voir ta gloire
                `,
                    "ref": true
                },
                {
                    "text": `Reçois ta guérison
                    Reçois ton miracle
                    Reçois cette nouvelle onction
                    Reçois cette fraîche onction
                    Qui descend sur toi
                    Les anges sont tout autour
                    Ils acclament la présence de Dieu dans ce lieu
                `,
                    "ref": false
                },
                {
                    "text": `Seigneur nous voulons voir ta gloire maintenant
                    Seigneur manifeste-toi
                    Nous voulons voir ta gloire
                    Les miracles sont relâchés maintenant
                    Les prodiges sont relâchés maintenant
                    La gloire de Dieu est relâchée maintenant
                    Alléluia
                `,
                    "ref": false
                },
                {
                    "text": `Je vois la gloire de Dieu descendre maintenant
                    Je prophétise
                    Je prophétise un changement dans ta vie maintenant
                    Pendant que tu es là dans ce lieu
                `,
                    "ref": false
                },
                {
                    "text": `Relâche les miracles
                    Relâche les prodigues
                    Relâche les anges
                    Relâche
                    Nous voulons voir ta gloire
                `,
                    "ref": false
                },
                {
                    "text": `Relâche les miracles
                    Relâche les prodigues
                    Relâche les anges
                    Relâche
                    Nous voulons voir ta gloire
                `,
                    "ref": true
                },
                {
                    "text": `Relâche les miracles
                    Relâche les prodigues
                    Relâche les anges
                    Relâche
                    Nous voulons voir ta gloire
                `,
                    "ref": true
                },
                {
                    "text": `Seigneur ouvre les écluses des cieux
                    Relâche ta gloire, Relâche ta gloire
                    Seigneur ouvre les écluses des cieux
                    Relâche ta gloire, Relâche ta gloire
                `,
                    "ref": false
                },
                {
                    "text": `Relâche ta gloire
                    Nous voulons te voir
                    Nous avons soif de toi
                    Révèle-toi
                    Fait entendre ta voix
                    Relâche ta gloire
                `,
                    "ref": true
                }
            ]
        },
        {
            "id": 3,
            "title": "Le Nom de Jésus",
            "image": "",
            "author": "version Jean Jean",
            "lyrics": [
                {
                    "text": `Que ton nom est majestueux, Seigneur Sur toute la terre
                Ton nom est fort et puissant
                Ton nom est glorieux et grand
                En lui nous sommes sauvés
                Le nom de Jésus plus haut que tous les noms
                Roi des Rois aucun nom n’est comme le sien
                Le nom de Jésus plus haut que tous les noms
                Alpha aucun nom n’est comme le sien
            `,
                    "ref": false
                },
                {
                    "text": `Ton nom est comme un doux parfum déversé sur mon âme
                En ton nom nous surmontons tout
                En ton nom nous avons la victoire Ton nom est tout puissant
            `,
                    "ref": false
                },
                {
                    "text": `Le nom de Jésus, plus haut que tous les noms
                Roi des rois, aucun nom n'est comme le sien
                Le nom de Jésus plus haut que tous les noms
                Alpha Oméga, aucun nom n'est comme le sien
                Le nom de Jésus, plus haut que tous les noms
                Roi des rois, aucun nom n'est comme le sien
            `,
                    "ref": true
                },
                {
                    "text": `Le nom de Jésus plus haut que tous les noms
                Alpha Oméga, aucun nom n'est comme le sien
                Le nom de Jésus, plus haut que tous les noms
                Roi des rois, aucun nom n'est comme le sien
                Le nom de Jésus plus haut que tous les noms
                Alpha Oméga, aucun nom n'est comme le sien
                Le nom de Jésus, plus haut que tous les noms
                Roi des rois, aucun nom n'est comme le sien
                Le nom de Jésus plus haut que tous les noms
                Alpha Oméga, aucun nom n'est comme le sien
            `,
                    "ref": true
                },
                {
                    "text": `Aucun autre Dieu n'a vaincu la mort
                Que Jésus-Christ le ressuscité
                Nous l'élevons plus haut
                En son nom tout genou fléchit
                En son nom tout homme est sauvé
                Nous invoquons son nom
            `,
                    "ref": true
                },
                {
                    "text": `Aucun autre Dieu n'a vaincu la mort
                Que Jésus-Christ le ressuscité
                Nous l'élevons plus haut
                En son nom tout genou fléchit
                En son nom tout homme est sauvé
                Nous invoquons son nom
            `,
                    "ref": true
                },
                {
                    "text": `Le nom de Jésus, plus haut que tous les noms
                Roi des rois, aucun nom n'est comme le sien
                Le nom de Jésus plus haut que tous les noms
                Alpha Oméga, aucun nom n'est comme le sien
            `,
                    "ref": true
                },
                {
                    "text": `Le nom de Jésus, plus haut que tous les noms 
                Roi des rois, aucun nom n'est comme le sien 
                Le nom de Jésus plus haut que tous les noms 
                Alpha Oméga, aucun nom n'est comme le sien 
                
                Le nom de Jésus, plus haut que tous les noms 
                Roi des rois, aucun nom n'est comme le sien 
                Le nom de Jésus plus haut que tous les noms 
                Alpha Oméga, aucun nom n'est comme le sien
                
                Le nom de Jésus, plus haut que tous les noms 
                Roi des rois, aucun nom n'est comme le sien 
                Le nom de Jésus plus haut que tous les noms 
                Alpha Oméga, aucun nom n'est comme le sien             
            `,
                    "ref": true
                },
                {
                    "text": `Jésus ! Jésus ! Jésus ! Oooh Jésus !
                Jésus ! Jésus ! Jésus ! Oooh Jésus !
            `,
                    "ref": true
                },
                {
                    "text": `Le nom de Jésus, plus haut que tous les noms 
                Roi des rois, aucun nom n'est comme le sien 
                Le nom de Jésus plus haut que tous les noms 
                Alpha Oméga, aucun nom n'est comme le sien 
            `,
                    "ref": false
                },
            ]
        },
        {
            "id": 4,
            "title": "Ce que Dieu a fait pour moi",
            "image": "",
            "author": "version Jean Jean",
            "lyrics": [
                {
                    "text": `Les ténèbres ont reculé
                Devant l’œuvre de la Croix
                Devant l’Agneau immolé
                Qui s’est sacrifié pour moi
                Que le faible dise je suis fort
                Que le pauvre dise je suis riche
                Que l’aveugle dise je peux voir
                Ce que Jésus a fait pour moi
                Hosanna, Hosanna
                À l’agneau immolé
                Hosanna, Hosanna
                Jésus est ressuscité
            `,
                    "ref": false
                },
                {
                    "text": `Les ténèbres ont reculé
                Devant l’œuvre de la Croix
                Devant l’Agneau immolé
                Qui s’est sacrifié pour moi
                Que le faible dise je suis fort
                Que le pauvre dise je suis riche
                Que l’aveugle dise je peux voir
                Ce que Jésus a fait pour moi
                Hosanna, Hosanna
                À l’agneau immolé
                Hosanna, Hosanna
                Jésus est ressuscité
            `,
                    "ref": true
                },
                {
                    "text": `Hosanna, Hosanna
                À l’agneau immolé
                Hosanna, Hosanna
                Jésus est ressuscité
                Hosanna, Hosanna
                À l’agneau immolé
                Hosanna, Hosanna
                Jésus est ressuscité
                Jésus est ressuscité
                Jésus est ressuscité
            `,
                    "ref": true
                }
            ]
        },
        {
            "id": 5,
            "title": "L’amour selon Dieu",
            "image": "",
            "author": "O’nel Mala",
            "lyrics": [
                {
                    "text": `Les gens s'ils m'aiment tant mieux
                    S'ils ne m'aiment pas tant pis pour eux
                    Mais le plus important qui fait mon bonheur
                `,
                    "ref": false
                },
                {
                    "text": "C'est l'amour de Dieu pour moi",
                    "ref": true
                },
                {
                    "text": `La la la la lalala
                    La la la la 
                    La la la la lalala
                    La la la la
                    C'est l'amour de Dieu pour moi
                `,
                    "ref": true
                },
                {
                    "text": `Je suis debout devant vous
                    Pour chanter l'amour
                    On ne le dira jamais assez
                    Dieu est amour
                    Laissez-vous aller
                    Laissez chanter en vous cet amour
                    Gens du monde entier
                    Laissez chanter en vous cet amour
                    Faites comme moi, faites comme moi
                    Car moi les gens s'ils m'aiment tant mieux
                    S'ils ne m'aiment pas tant pis pour eux
                    Mais le plus important qui fait mon bonheur
                `,
                    "ref": false
                },
                {
                    "text": "C'est l'amour de Dieu pour moi",
                    "ref": true
                },
                {
                    "text": `S'ils m'écoutent tant mieux
                    Si ce n'est pas le cas, tant pis aussi
                    Mais le plus important qui fait mon bonheur
                `,
                    "ref": false
                },
                {
                    "text": `C'est l'amour de Dieu pour moi
                    Je parle de celui qui est patient et plein de bonté
                `,
                    "ref": true
                },
                {
                    "text": "Qui ne soupçonne point le mal, qui pardonne, Aussi qui donne",
                    "ref": true
                },
                {
                    "text": `yeah, qui donne, yeah, qui donne, yeah
                    Oh, oui c'est celui qui est
                `,
                    "ref": false
                },
                {
                    "text": `Patient et plein de bonté
                    Qui ne soupçonne point le mal, qui pardonne
                    Aussi qui donne
                `,
                    "ref": true
                },
                {
                    "text": "yeah, qui donne yeah, qui donne, yeah",
                    "ref": false
                },
                {
                    "text": "C’est l’amour de Dieu pour moi",
                    "ref": true
                },
                {
                    "text": `Seul cet amour nous met au-dessus
                    De tous les coups durs qui nous ont déçus
                    Laissez-vous allez
                    Laissez-vous aller frères, sœurs
                    Voyez la beauté de mon histoire
                    C'est son amour 
                `,
                    "ref": false
                },
                {
                    "text": "C'est son amour – amour",
                    "ref": true
                },
                {
                    "text": `Les plus pages de mon histoire
                    Oh c'est son amour
                `,
                    "ref": false
                },
                {
                    "text": "C'est son amour – amour",
                    "ref": true
                },
                {
                    "text": `Admirez la force de mon histoire
                    C'est son amour
                    Je parle de celui qui est patient et plein de bonté
                `,
                    "ref": false
                },
                {
                    "text": "Qui ne soupçonne point le mal, qui pardonne aussi qui donne",
                    "ref": true
                },
                {
                    "text": `yeah, qui donne yeah, qui donne, yeah
                    Qui donne, yeah
                `,
                    "ref": false
                },
                {
                    "text": "C’est l’amour de Dieu pour moi",
                    "ref": true
                },
                {
                    "text": `Oh, oui
                    Celui qui est patient et plein de bonté
                `,
                    "ref": false
                },
                {
                    "text": "Qui ne soupçonne point le mal, qui pardonne, Aussi qui donne",
                    "ref": true
                },
                {
                    "text": "yeah, qui donne yeah, qui donne, yeah",
                    "ref": false
                },
                {
                    "text": "C’est l’amour de Dieu pour moi",
                    "ref": true
                },
                {
                    "text": `Cet amour-là
                    Il faut l'avoir en vous là, yeah, yeah, yeah
                `,
                    "ref": true
                },
                {
                    "text": "Amour, amour",
                    "ref": false
                },
                {
                    "text": "Amour, amour",
                    "ref": true
                },
                {
                    "text": "Humilié, rejeté",
                    "ref": false
                },
                {
                    "text": "Amour, amour",
                    "ref": true
                },
                {
                    "text": "L'amour de Dieu peut te retrouver",
                    "ref": false
                },
                {
                    "text": "Amour, amour",
                    "ref": true
                },
                {
                    "text": "Ta dignité bafouée",
                    "ref": false
                },
                {
                    "text": "Amour, amour",
                    "ref": true
                },
                {
                    "text": "L'amour de Dieu peut te restaurer",
                    "ref": false
                },
                {
                    "text": "Il fait des miracles",
                    "ref": false
                },
                {
                    "text": "miracles",
                    "ref": true
                },
                {
                    "text": "Il fait des miracles",
                    "ref": false
                },
                {
                    "text": "miracles",
                    "ref": true
                },
                {
                    "text": "Il fait des miracles",
                    "ref": false
                },
                {
                    "text": "oh oui",
                    "ref": true
                },
                {
                    "text": "Il fait des miracles",
                    "ref": false
                },
                {
                    "text": "miracles",
                    "ref": true
                },
                {
                    "text": "Il fait des miracles",
                    "ref": false
                },
                {
                    "text": "miracles",
                    "ref": true
                },
                {
                    "text": "Il fait des miracles",
                    "ref": false
                },
                {
                    "text": "oh oui",
                    "ref": true
                },
                {
                    "text": "Oh yeah, oh yeah",
                    "ref": false
                },
                {
                    "text": "Amour – amour ",
                    "ref": true
                },
                {
                    "text": "C'est ça l'amour",
                    "ref": false
                },
                {
                    "text": "Amour – amour ",
                    "ref": true
                },
                {
                    "text": "Ooooooooh",
                    "ref": false
                },
                {
                    "text": "Amour – amour  ",
                    "ref": true
                },
                {
                    "text": "C'est ça l'amour",
                    "ref": false
                },
                {
                    "text": `Les gens s'ils t'aiment tant mieux
                    S'ils ne t'aiment pas tant pis pour eux
                    Mais le plus important pour toi qui fera ton bonheur
                `,
                    "ref": false
                },
                {
                    "text": "C'est l'amour de Dieu pour toi",
                    "ref": true
                },
            ]
        },
        {
            "id": 6,
            "title": "Persévère",
            "image": "",
            "author": "Olivier Cheuwa",
            "lyrics": [
                {
                    "text": `Si Dieu a mis un rêve dans ton cœur
                    Écris-le, garde-le comme un trésor
                    Quoi qu'on dise
                    Protège la vision avec passion
                    Oh oui
                    Quand tu sais, tu sais de tout ton être
                    Que ce rêve ne vient pas de toi
                    Même si, tu ne vois que le contraire
                    Persévère, oh oui
                    Persévère
                    Persévère
                    Persévère
                    Persévère
                    Car sa parole, elle s'accomplira
                `,
                    "ref": false
                },
                {
                    "text": `Si dans ton cœur est réelle cette promesse
                    Quand vient le doute, lève-toi et confesse
                `,
                    "ref": false
                },
                {
                    "text": `Que Dieu est vrai et que sa parole demeure éternelle
                    Car ce qu'il promet, mon frère, ma sœur n'est jamais vain
                    Toujours fidèle et son chemin certain
                    Même si les choses semblent n'aboutir à rien
                    Persévère
                    Quand il dit
                    La chose arrive
                    Quand il ordonne
                    Elle existe
                    Son regard est sur ce qui lui appartient
                `,
                    "ref": false
                },
                {
                    "text": `Persévère
                    Persévère
                    Persévère
                    Persévère
                `,
                    "ref": true
                },
                {
                    "text": "Encore une fois persévère",
                    "ref": false
                },
                {
                    "text": `Persévère
                    Persévère
                    Persévère
                    Persévère
                `,
                    "ref": true
                },
                {
                    "text": "Car sa parole",
                    "ref": false
                },
                {
                    "text": "elle s'accomplira",
                    "ref": true
                },
                {
                    "text": "oh oui",
                    "ref": false
                },
                {
                    "text": "Elle s'accomplira",
                    "ref": true
                },
                {
                    "text": "oh oui",
                    "ref": false
                },
                {
                    "text": "Elle s'accomplira",
                    "ref": true
                },
                {
                    "text": "Certainement, oh oui",
                    "ref": false
                },
                {
                    "text": "Elle s'accomplira",
                    "ref": true
                }
            ]
        },
        {
            "id": 7,
            "title": 'Qui m\'apaise',
            "image": '',
            "author": 'TayC',
            "lyrics ": [
                {
                    "text": `Qui m'apaise, qui m'apaise, oh, c'est toi
                    Qui m'apaise, qui m'apaise, oh, c'est toi
                    Qui m'élève, qui m'allège, oh, c'est toi
                    Qui m'apaise, qui m'apaise, oh, c'est toi
                    Je n'suis qu'un homme, j'suis tellement faible
                    Mais chaque fois que je tombe, tu me relèves
                    Je n'suis qu'un homme, j'suis tellement faible
                    Mais chaque fois que je tombe, tu me relèves, oh mamie
                    Qui m'apaise, qui m'apaise, oh, c'est toi
                    Qui m'apaisе, qui m'apaise, oh, c'est toi
                    Qui m'élève, qui m'allège, oh, c'est toi
                    Qui m'apaise, qui m'apaise, oh, c'est toi
                    Je n'suis qu'un homme, j'suis tellement faible
                    Mais chaque fois que je tombe, tu me relèves
                    J'ai tellement honte, j'me sens si mal
                    Mais à chaque fois que je salis, c'est toi qui laves oh mamie
                    Qui m'apaise, qui m'apaise, oh, c'est toi
                    Qui m'apaise, qui m'apaise, oh, c'est toi
                    Qui m'élève, qui m'allège, oh, c'est toi
                    Qui m'apaise, qui m'apaise, oh, c'est toi
                    Oh tu m'as longtemps, tu m'as longtemps pardonné
                    Mais est-ce que je le mérite, dis-moi est-ce que je le mérite
                    Et tu as appris, appris à toujours regarder tout c'que je fais
                    En oubliant c'que je ne fais pas, mamie, mamie
                    Et Dieu t'as tellement bien faite
                    Oh si tu restes c'est parce que tu sais qu'j'suis pas mauvais
                    Tu connais mon cœur, oh
                    Mamie je te dois tout
                    Quand je mourrai, prends tout, ooh prends tout, ooh, ouh ooh
                    Qui m'apaise, qui m'apaise, ouh, c'est toi
                    Qui m'apaise, qui m'apaise, oh, c'est toi
                    Qui m'élève, qui m'allège, oh, c'est toi
                    Qui m'apaise, qui m'apaise, oh, c'est toi
                `,
                    "ref": false
                }
            ]
        },
        {
            "id": 8,
            "title": 'Vêtu de gloire ',
            "image": '',
            "author": 'O’nel Mala',
            "lyrics ": [
                {
                    "text": `Vêtu de gloire
                    Le fils de l'homme reviendra
                    Et on l'appellera
                    Le lion de la tribu de Juda
                    Vêtu de Gloire
                    Adonaï viendra
                    Et on l'appellera
                    Le lion de la tribu de Juda
                `,
                    "ref": false
                },
                {
                    "text": "Ce jour-là",
                    "ref": false
                },
                {
                    "text": "ce jour-là",
                    "ref": true
                },
                {
                    "text": "On dira",
                    "ref": false
                },
                {
                    "text": "on dira",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "alléluia",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "alléluia",
                    "ref": true
                },
                {
                    "text": `Il viendra pour toi et pour moi
                    Nous qui avons gardé la foi
                    Il sera notre roi
                    Il sera le sujet de notre joie
                    Tout œil le verra
                    Toute langue le confessera
                    Devant lui tout genou fléchira
                    Tout genou fléchira
                    Lui rendant honneur et gloire
                `,
                    "ref": false
                },
                {
                    "text": "On dira",
                    "ref": false
                },
                {
                    "text": "on dira",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "alléluia",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "alléluia",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "alléluia",
                    "ref": true
                },
                {
                    "text": "Oh ce jour-là",
                    "ref": false
                },
                {
                    "text": "ce jour-là",
                    "ref": true
                },
                {
                    "text": "On dira",
                    "ref": false
                },
                {
                    "text": "on dira",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "alléluia",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "alléluia",
                    "ref": true
                },
                {
                    "text": `L'aveugle le verra
                    Et même le sourd l'entendra
                    Le muet le chantera
                    Pour lui, le paralytique se lèvera
                    `,
                    "ref": false
                },
                {
                    "text": "Ce jour-là",
                    "ref": false
                },
                {
                    "text": "ce jour-là",
                    "ref": true
                },
                {
                    "text": "On dira",
                    "ref": false
                },
                {
                    "text": "on dira",
                    "ref": true
                },
                {
                    "text": "Maranatha",
                    "ref": false
                },
                {
                    "text": "Maranatha",
                    "ref": true
                },
                {
                    "text": "Maranatha",
                    "ref": false
                },
                {
                    "text": "Maranatha",
                    "ref": true
                },
                {
                    "text": "Ce jour-là",
                    "ref": false
                },
                {
                    "text": "ce jour-là",
                    "ref": true
                },
                {
                    "text": "On dira",
                    "ref": false
                },
                {
                    "text": "on dira",
                    "ref": true
                },
                {
                    "text": "Maranatha",
                    "ref": false
                },
                {
                    "text": "Maranatha",
                    "ref": true
                },
                {
                    "text": "Maranatha",
                    "ref": false
                },
                {
                    "text": "Maranatha",
                    "ref": true
                },
                {
                    "text": `Il est Dieu des orphelins
                    Nul ne sait le jour ni l'heure
                    Mais le Maître arrive
                    Jésus
                    Et les signes sont évidents
                    Prépare-toi à la rencontre de ton maître
                    Si tu m'entends
                    Chante avec moi ce chant
                `,
                    "ref": false
                },
                {
                    "text": "Vêtu de gloire",
                    "ref": false
                },
                {
                    "text": "vêtu de gloire",
                    "ref": true
                },
                {
                    "text": "Le fils de l'homme reviendra",
                    "ref": false
                },
                {
                    "text": "chante avec moi",
                    "ref": false
                },
                {
                    "text": "Et on l'appellera",
                    "ref": false
                },
                {
                    "text": "et on l'appellera",
                    "ref": true
                },
                {
                    "text": "Le lion de la tribu de Juda",
                    "ref": false
                },
                {
                    "text": "le lion de la tribu de Juda",
                    "ref": true
                },
                {
                    "text": "On reprend",
                    "ref": false
                },
                {
                    "text": "Vêtu de gloire",
                    "ref": false
                },
                {
                    "text": "vêtu de gloire",
                    "ref": true
                },
                {
                    "text": "Le fils de l'homme reviendra",
                    "ref": false
                },
                {
                    "text": "le fils de l'homme reviendra",
                    "ref": true
                },
                {
                    "text": "Et on l'appellera",
                    "ref": false
                },
                {
                    "text": "et on l'appellera",
                    "ref": true
                },
                {
                    "text": "Le lion de la tribu de Juda",
                    "ref": false
                },
                {
                    "text": "le lion de la tribu de Juda",
                    "ref": true
                },
                {
                    "text": "Alors debout et chante avec moi",
                    "ref": false
                },
                {
                    "text": "On dira",
                    "ref": false
                },
                {
                    "text": "on dira",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "alléluia",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "alléluia",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "alléluia",
                    "ref": true
                },
                {
                    "text": "On dira",
                    "ref": false
                },
                {
                    "text": "on dira",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "alléluia",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "alléluia",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "alléluia",
                    "ref": true
                },
                {
                    "text": "On dira",
                    "ref": false
                },
                {
                    "text": "on dira",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "alléluia",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "alléluia",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "alléluia",
                    "ref": true
                },{
                    "text": "On dira",
                    "ref": false
                },
                {
                    "text": "on dira",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "alléluia",
                    "ref": true
                },
                {
                    "text": "Alléluia",
                    "ref": false
                },
                {
                    "text": "alléluia",
                    "ref": true
                },
                {
                    "text": `Ce sera trop beau
                    Ce sera trop merveilleux pour que tu rates ça, mon frère
                    Toi aussi ma sœur
                    Alléluia
                `,
                    "ref": false
                },
            ]
        },
        {
            "id": 9,
            "title": 'Mon Dieu est Puissant',
            "image": '',
            "author": 'Inconnu',
            "lyrics" : [
                {
                    "text": `Il déplace les montagnes
                    Il me cache sous Ses ailes
                    M’abrite sous Son ombre
                    Mon Dieu est puissant
                    C’est Lui qui me guérit
                    Lui qui me fortifie
                    Il règne éternellement
                    `,
                    "ref": false
                },
                {
                    "text": `Il déplace les montagnes
                    Il me cache sous Ses ailes
                    M’abrite sous Son ombre
                    Mon Dieu est puissant
                    C’est Lui qui me guérit
                    Lui qui me fortifie
                    Il règne éternellement
                `,
                    "ref": true
                },
                {
                    "text": `Mon Dieu est puissant, puissant, puissant
                    Mon Dieu est puissant, puissant, puissant
                `,
                    "ref": true
                },
                {
                    "text": `Mon Dieu est puissant
                    Sauveur de l’univers
                    Lui seul offre le salut
                    En Lui je suis béni
                    Mon Dieu est puissant
                    Il m’a tout pardonné
                    Sa grâce m’a tout délivré
                    Il m’a restauré
                `,
                    "ref": false
                },
                {
                    "text": `Mon Dieu est puissant
                    Sauveur de l’univers
                    Lui seul offre le salut
                    En Lui je suis béni
                    Mon Dieu est puissant
                    Il m’a tout pardonné
                    Sa grâce m’a tout délivré
                    Il m’a restauré 
                `,
                    "ref": true
                },
                {
                    "text": `Mon Dieu est puissant, puissant, puissant 
                    Mon Dieu est puissant, puissant, puissant
                    Mon Dieu est puissant, puissant, puissant 
                    Mon Dieu est puissant, puissant, puissant
                    
                    Tout puissant … (*4)
                    Puissant, mon Dieu est puissant
                    
                    Il est Saint… (*4)
                    Puissant, mon Dieu est puissant
                    
                    Conquérant… (*4)
                    Puissant, mon Dieu est puissant
                    
                    Triomphant… (*4)
                    Puissant, mon Dieu est puissant
                    
                    Redoutable… (*4)
                    Puissant, mon Dieu est puissant
                    
                    (Il est) Grand… (*4)
                    Puissant, mon Dieu est puissant
                    
                    Merveilleux (*4)
                    Puissant, mon Dieu est puissant
                    
                    Glorieux (*4)
                    Puissant, mon Dieu est puissant
                `,
                    "ref": true
                },
                {
                    "text": `Il déplace les montagnes
                    Il me cache sous Ses ailes
                    M’abrite sous Son ombre
                    Mon Dieu est puissant
                    C’est Lui qui me guérit
                    Lui qui me fortifie
                    Il règne éternellement….
                `,
                    "ref": true
                },
            ]
        },
        {
            "id": 10,
            "title": 'A l\'agneau',
            "image": '',
            "author": 'version Exo',
            "lyrics" : [
                {
                    "text": `Tous les anges louent sa sainteté
                    L'univers crie sa majesté
                    Chantons gloire et puissance, force et louange
                    À l'agneau
                    À l'agneau immolé
                    À l'agneau
                    À l'agneau immolé
                `,
                    "ref": false
                },
                {
                    "text": `Tous les anges louent sa sainteté
                    L'univers crie sa majesté
                    Chantons gloire et puissance, force et louange
                    À l'agneau
                    À l'agneau immolé
                    À l'agneau
                    À l'agneau immolé
                `,
                    "ref": true
                },
                {
                    "text": `Les ténèbres ont reculé
                    Devant l'œuvre de la croix
                    Devant l'agneau immolé
                    Et le sang versé pour moi
                `,
                    "ref": false
                },
                {
                    "text": `Tous les anges louent sa sainteté
                    L'univers crie sa majesté
                    Chantons gloire et puissance, force et louange
                    À l'agneau
                    À l'agneau immolé
                    À l'agneau
                    À l'agneau immolé
                `,
                    "ref": true
                },
                {
                    "text": `De la vie qu'il a donnée
                    À la vie qui brûle en moi
                    Ton amour est à jamais
                    Ma reconnaissance au roi
                `,
                    "ref": false
                },
                {
                    "text": `Tous les anges louent sa sainteté 
                    L'univers crie sa majesté
                    Chantons gloire et puissance, force et louange
                    À l'agneau
                    À l'agneau immolé
                    À l'agneau
                    À l'agneau immolé
                `,
                    "ref": true
                },
                {
                    "text": `Vivant
                    Vivant
                    Puissant
                    Puissant
                    Vivant
                    Dieu vivant
                    Puissant
                    Tout Puissant
                    Dieu vivant, Dieu Tout Puissant
                    Dieu vivant, Dieu Tout Puissant
                    Tous les anges louent sa sainteté
                    L'univers crie sa majesté
                    Chantons gloire et puissance, force et louange
                    Chantons gloire et puissance, force et louange
                    Chantons gloire et puissance, force et louange
                    À l'agneau
                    À l'agneau immolé
                    À l'agneau
                    À l'agneau immolé
                    À l'agneau
                    À l'agneau immolé
                    À l'agneau
                    À l'agneau immolé
                `,
                    "ref": true
                },
            ]
        },
        {
            "id": 11,
            "title": "Rien que le sang de Jésus",
            "image": "",
            "author": "version Obed Bertin",
            "lyrics": [
                {
                    "text": `Rien ne peut sauver mon âme
                    Rien que le sang de Jésus
                    Pour elle je ne réclame
                    Rien que le sang de Jésus 
                    Précieux sang de l’Agneau
                    Qui me donne un cœur nouveau
                    Rien d’autre, je ne veux plus
                    Rien que le sang de Jésus
                    Pour mon pardon je ne vois
                    Rien que le sang de Jésus
                    Pour mon salut je ne crois
                    Rien que le sang de Jésus
                `,
                    "ref": false
                },
                {
                    "text": `Rien ne peut sauver mon âme
                    Rien que le sang de Jésus
                    Pour elle je ne réclame
                    Rien que le sang de Jésus
                    Précieux sang de l’Agneau
                    Qui me donne un cœur nouveau
                    Rien d’autre, je ne veux plus
                    Rien que le sang de Jésus
                    Pour mon pardon je ne vois
                    Rien que le sang de Jésus
                    Pour mon salut je ne crois
                    Rien que le sang de Jésus
                `,
                    "ref": true
                },
                {
                    "text": `Rien ne peut sauver mon âme
                    Rien que le sang de Jésus
                    Pour elle je ne réclame
                    Rien que le sang de Jésus
                    Précieux sang de l’Agneau
                    Qui me donne un cœur nouveau
                    Rien d’autre, je ne veux plus
                    Rien que le sang de Jésus
                    Pour mon pardon je ne vois
                    Rien que le sang de Jésus
                    Pour mon salut je ne crois
                    Rien que le sang de Jésus
                `,
                    "ref": true
                }
            ]
        },
        {
            "id": 12,
            "title": 'Nan Zéwé daga',
            "image": '',
            "author": 'Appolinaire Soglo',
            "lyrics" : [
                {
                    "text": "Texte indisponible",
                    "ref": false
                }
            ]
        },
        {
            "id": 13,
            "title": 'Fiyémalin',
            "image": '',
            "author": 'Gildas Zinsou',
            "lyrics" : [
                {
                    "text": "Texte indisponible",
                    "ref": false
                }
            ]
        },
        {
            "id": 14,
            "title": "Abassi",
            "image": "",
            "author": "Bruno Kpossou",
            "lyrics": [
                {
                    "text": "Abassi kluno guigino Lèsukpo ,yin mando noudé bonanawé toli enfin youtou wèzon bo yin wa to kpèdo na wé okpè nawé gigono",
                    "ref": true
                }
            ]
        },
        {
            "id": 15,
            "title": "Aholou gigo ton",
            "image": "",
            "author": "Bruno Kpossou",
            "lyrics": [
                {
                    "text": "Aholu gigoton nibiô wegbéwaa Jésus huhlon no Asuka Mizé otami ton lè taga ,mi ou yongbo émi ,misòyi zizé doaga ,miou mandokpodo émi na aholu gigoton ni bio wégbé wa",
                    "ref": true
                },
                {
                    "text": "Bawa wa noudjaou",
                    "ref": false
                },
                {
                    "text": "Jesu",
                    "ref": false
                },
                {
                    "text": "Jésus huhlon no Asuka",
                    "ref": false
                }
            ]
        },
        {
            "id": 16,
            "title": "Adjalonnon",
            "image": "",
            "author": "Raphaël Sheyi",
            "lyrics" : [
                {
                    "text": "Texte indisponible",
                    "ref": false
                }
            ]
        },
        {
            "id": 17,
            "title": "Capable God",
            "image": "",
            "author": "Judikay",
            "lyrics": [
                {
                    "text": "Uh oh oh oh oh oh oh\nCapable God o\nWhat can't you do?\nWhat won't you do?\nNothing impossible\nNothing impossible\nWhat can't you do?\nWhat won't you do?\nNothing impossible with our God",
                    "ref": false
                },
                {
                    "text": "You do not lie\nYou do not fail\nWhat is hard for you to do?\nIt doesn't exist oh\nIt can never ever exist oh",
                    "ref": false
                },
                {
                    "text": "You do not lie\nYou do not fail\nWhat is hard for you to do?\nIt doesn't exist oh\nIt can never ever exist oh",
                    "ref": true
                },
                {
                    "text": "According to your knowledge and your will for me\nWhat you say you have done\nI just need to align oh\nBecause you are not a man that changes your mind oh\nThose that know you will trust in you\nNot in Horses and chariots\nBy the arm of flesh\nNo man can prevail\nNo man, No man\nNo man, No man\nMy confidence is you\nWhat is hard?\nWhat is hard for you?\nIt can never exist oh",
                    "ref": false
                },
                {
                    "text": "You do not lie\nYou do not fail\nWhat is hard for you to do?\nIt doesn't exist oh\nIt can never ever exist oh",
                    "ref": true
                },
                {
                    "text": "You do not lie\nYou do not fail\nWhat is hard for you to do?\nTo do ooh-ooh-ooh-ooh\nIt can never ever exist oh",
                    "ref": false
                },
                {
                    "text": "Those that know you will trust in you\nNot in Horses and chariots\nBy the arm of flesh",
                    "ref": false
                },
                {
                    "text": "No man can prevail\nAsk Abraham and Sarah\nAnd the Woman with the issue of blood oh\nNothing nothing hard for you-you-you-you",
                    "ref": false
                },
                {
                    "text": "Ask Mama Hannah",
                    "ref": true
                },
                {
                    "text": "Ask Mama Hannah oh\nBlind Bartimaeus\nMake you go ask the Israelites\nAbsolutely nothing hard for you",
                    "ref": false
                },
                {
                    "text": " No man, no man, no man. My confidence is you. What is hard?What is hard for you? It can never exist oh",
                    "ref": false
                },
                {
                    "text": "You do not lie. You do not fail. What is hard for you to do?. It doesn't exist oh. It can never ever exist oh. You do not lie. You do not fail. What is hard for you to do? It doesn't exist oh. It can never ever exist oh",
                    "ref": true
                },
                {
                    "text": "No no no no no\nCapable God oh oh\nIt can never ever exist oh",
                    "ref": false
                }
            ]
        },
        {
            "id": 18,
            "title": "Dieu n’échoue jamais",
            "image": "",
            "author": "KS Bloom",
            "lyrics": [
                {
                    "text": "Dieu n'échoue jamais, hein\nC'est quel problème qui le fait reculer\nJe suis son enfant\nPapa est là, je n'peux échouer\nDieu n'échoue jamais, hein\nC'est quel problème qui le fait reculer\nIl ne ment jamais, hein\nC'est quelle promesse il peut pas assumer\nJe suis son enfant\nPapa est là, je n'peux pas échouer\nSa main est sur moi oh, sur moi, sur moi\nC'est quel projet je n'peux pas tuer",
                    "ref": false
                },
                {
                    "text": "S'il y a des hommes pour prier\nC'est parce qu'il y a un Dieu pour exaucer\nChaque chose en son temps, ma victoire arrive\nParce que j'suis pas né pour pleurer (jamais, jamais)\nEnfant de Dieu n'aime pas la galère\nEnfant de Dieu n'aime pas facilité\nJe poursuis ma vision, je n'arrête pas\nFaut aimer mon affaire si tu es fâché\nQuand travail est semé\nC'est succès qu'on moissonne\nLe Saint Esprit m'a touché pour gagner les nations\nAllô, allô le bonheur\nNi abradagou la ga lado\nÇa veut dire pourquoi depuis là tu ne vas pas chez les jaloux aussi\nAttention",
                    "ref": false
                },
                {
                    "text": "Dieu n'échoue jamais, hein\nC'est quel problème qui le fait reculer\nIl ne ment jamais, hein\nC'est quelle promesse il peut pas assumer eh-eh\nJe suis son enfant anh-anh-anh\nPapa est là, je n'peux pas échouer\nSa main est sur moi oh, sur moi, sur moi\nC'est quel projet que je n'peux pas tuer",
                    "ref": true
                },
                {
                    "text": "Oh les gens sont méchants\nNous les enfants de Dieu\nIls aiment quand on n'a pas d'argent\nMais ils sont vaincus, pour réussir il faut être têtu\nMoi aussi je vais payer ma voiture\nJe sais qui je suis donc je ne m'inquiète plus\nIls complotent contre nous\nComme les Egyptiens ils vont se noyer\nIls n'peuvent rien contre nous\nLe Dieu tout puissant demeure notre allié (ah-ah-ah)\nJ'ai Dieu dans ma vie\nJ'sais que je n'serais jamais dernier",
                    "ref": false
                },
                {
                    "text": "Dieu n'échoue jamais, hein\nC'est quel problème qui le fait reculer\nIl ne ment jamais, hein\nC'est quelle promesse il peut pas assumer eh-eh\nJe suis son enfant\nPapa est là, je n'peux pas échouer\nSa main est sur moi oh, sur moi, sur moi\nC'est quel projet que je n'peux pas tuer",
                    "ref": true
                },
                {
                    "text": "Attendez, attendez, attendez (okay, okay, okay). Doucement, doucement, doucement, doucement, doucement. Oh la danse de la victoire. (Allumez la lumière).Si problème veut créer sur toi. Rappelle-lui qui est ton papa. Enfant de Dieu ne lutte pas, père Ramba ",
                    "ref": false
                }
            ]
        },
        {
            "id": 19,
            "title": "Je suis dans la joie",
            "image": "",
            "author": "Pasteur Guy",
            "lyrics": [
                {
                    "text": "Je chanterais de tout cœur les merveilles de mon Papa Yahweh\nQui m’a ôté des ténèbres et m’a délivré de tous péchés\nJe chanterais de tout cœur les merveilles de mon Papa Yahweh\nQui m’a ôté des ténèbres et m’a délivré de tous péchés",
                    "ref": false
                },
                {
                    "text": "Mon papa est fidèle\nIl ne m'abandonne jamais\nJe n'ai plus rien à craindre\nCar Yahweh m’a libéré\nMon papa est fidèle\nIl ne m'abandonne jamais\nJe n'ai plus rien à craindre\nCar Yahweh m’a libéré",
                    "ref": false
                },
                {
                    "text": "Je suis dans la joie, une joie immense\nJe suis dans l'émotion, car Yahweh m’a libéré\nJe suis dans la joie, une joie immense\nJe suis dans l'émotion, car Yahweh m’a libéré",
                    "ref": true
                },
                {
                    "text": "Mon papa est fidèle\nIl ne m'abandonne jamais\nJe n'ai plus rien à craindre\nCar Yahweh m’a libéré\nMon papa est le plus fidèle\nIl ne m'abandonne jamais\nJe n'ai plus rien à craindre\nCar Yahweh m’a libéré",
                    "ref": false
                },
                {
                    "text": "Je suis dans la joie, une joie immense\nJe suis dans l'émotion, car Yahweh ma libéré\nJe suis dans la joie, une joie immense\nJe suis dans l'émotion, car Yahweh m’a libéré",
                    "ref": false
                },
                {
                    "text": "Je suis dans la joie, une joie immense\nJe suis dans l'émotion, car Yahweh m’a libéré\nJe suis dans la joie, une joie immense\nJe suis dans l'émotion, car Yahweh m’a libéré\nJe suis dans la joie, une joie immense\nJe suis dans l'émotion, car Yahweh m’a libéré\nJe suis dans la joie, une joie immense\nJe suis dans l'émotion, car Yahweh m’a libéré",
                    "ref": true
                }
            ]
        },
        {
            "id": 20,
            "title": "Louez l’Eternel",
            "image": "",
            "author": "La Harpe de David",
            "lyrics": [
                {
                    "text": "Louez l’Eternel, car Il est bon",
                    "ref": false
                },
                {
                    "text": "Car Sa miséricorde dure à toujours",
                    "ref": false
                },
                {
                    "text": "Que ceux qui craignent l’Eternel disent",
                    "ref": false
                },
                {
                    "text": "Car Sa miséricorde dure à toujours",
                    "ref": false
                },
                {
                    "text": "Du sein de la détresse, j’ai invoqué l’Eternel",
                    "ref": false
                },
                {
                    "text": "L’Eternel m’a exaucé, Il m’a mise au large",
                    "ref": false
                },
                {
                    "text": "Je te louerai parce que Tu m’as exaucé,",
                    "ref": false
                },
                {
                    "text": "Parce que tu m’as sauvé. Alléluia, Alléluia….",
                    "ref": false
                },
                {
                    "text": "Non je ne mourrai pas je vivrai",
                    "ref": true
                },
                {
                    "text": "Non je ne mourrai pas je vivrai",
                    "ref": true
                },
                {
                    "text": "Je raconterai les œuvres de l’Eternel",
                    "ref": true
                },
                {
                    "text": "Je raconterai les bontés de mon sauveur, je ne mourrai pas yeah",
                    "ref": true
                },
                {
                    "text": "L’Eternel est mon berger je ne manquerai de rien",
                    "ref": false
                },
                {
                    "text": "Il me fait reposer dans de verts pâturages",
                    "ref": false
                },
                {
                    "text": "A cause de son nom je vivrai, je ne mourrai pas non",
                    "ref": false
                },
                {
                    "text": "Non je ne mourrai pas je vivrai",
                    "ref": true
                },
                {
                    "text": "Non, non, non",
                    "ref": false
                },
                {
                    "text": "Je raconterai les œuvres de l’Eternel",
                    "ref": true
                },
                {
                    "text": "je raconterai, je raconterai eh",
                    "ref": false
                },
                {
                    "text": "Je raconterai les bontés de mon sauveur, je ne mourrai pas yeah",
                    "ref": true
                },
                {
                    "text": "Quand je marche dans la vallée de l’ombre de la mort je ne crains aucun mal",
                    "ref": false
                },
                {
                    "text": "Car tu es avec moi, ta houlette et ton bâton",
                    "ref": false
                },
                {
                    "text": "Me rassurent, me rassurent, je ne mourrai pas yeah",
                    "ref": false
                },
                {
                    "text": "Non je ne mourrai pas je vivrai",
                    "ref": true
                },
                {
                    "text": "Je raconterai les œuvres de l’Eternel",
                    "ref": true
                },
                {
                    "text": "je raconterai, je raconterai eh",
                    "ref": false
                },
                {
                    "text": "Je raconterai les bontés de mon sauveur, je ne mourrai pas yeah",
                    "ref": true
                },
                {
                    "text": "Mouillez, mouillez, mouillez, mouillez, mouillez, mouillez, mouillez, mouillez, mouillez, mouillez",
                    "ref": false
                },
                {
                    "text": "Eh pi, Eh pita / Eh pi, Eh pita",
                    "ref": true
                },
                {
                    "text": "Mouillez, mouillez, mouillez, mouillez, mouillez, mouillez, mouillez, mouillez, mouillez, mouillez",
                    "ref": false
                },
                {
                    "text": "Eh pi, Eh pita / Eh pi, Eh pita",
                    "ref": true
                },
                {
                    "text": "Je ne mourrai pas",
                    "ref": false
                },
                {
                    "text": "Non !",
                    "ref": true
                },
                {
                    "text": "Je ne mourrai pas",
                    "ref": false
                },
                {
                    "text": "Non !",
                    "ref": true
                },
                {
                    "text": "Je ne mourrai pas",
                    "ref": false
                },
                {
                    "text": "Non !",
                    "ref": true
                },
                {
                    "text": "Je vivrai",
                    "ref": false
                },
                {
                    "text": "Oui !",
                    "ref": true
                },
                {
                    "text": "Je réussirai",
                    "ref": false
                },
                {
                    "text": "Oui !",
                    "ref": true
                },
                {
                    "text": "Je prospèrerai",
                    "ref": false
                },
                {
                    "text": "Oui !",
                    "ref": true
                },
                {
                    "text": "Je me marierai",
                    "ref": false
                },
                {
                    "text": "Oui !",
                    "ref": true
                },
                {
                    "text": "Je voyagerai",
                    "ref": false
                },
                {
                    "text": "Oui !",
                    "ref": true
                },
                {
                    "text": "Et j’avancerai",
                    "ref": false
                },
                {
                    "text": "Oui !",
                    "ref": true
                },
                {
                    "text": "Je travaillerai",
                    "ref": false
                },
                {
                    "text": "Oui !",
                    "ref": true
                },
                {
                    "text": "Je ne mourrai pas",
                    "ref": false
                },
                {
                    "text": "Non !",
                    "ref": true
                },
                {
                    "text": "Je ne mourrai pas",
                    "ref": false
                },
                {
                    "text": "Non !",
                    "ref": true
                },
                {
                    "text": "Je ne mourrai pas",
                    "ref": false
                },
                {
                    "text": "Non !",
                    "ref": true
                },
                {
                    "text": "Yeba, ma folie oooooh",
                    "ref": false
                },
                {
                    "text": "C’est Jésus !",
                    "ref": true
                },
                {
                    "text": "Tu connais le numéro portable du Saint Esprit ?",
                    "ref": false
                },
                {
                    "text": "c’est lequel ?",
                    "ref": true
                },
                {
                    "text": "Jérémie 33 verset 3",
                    "ref": false
                },
                {
                    "text": "Hannnn, invoques moi au jour de la détresse et je te répondrai",
                    "ref": true
                },
                {
                    "text": "C’est ça qui est la vérité",
                    "ref": false
                },
                {
                    "text": "Instrumental",
                    "ref": false
                },
                {
                    "text": "Non je ne mourrai pas je vivrai",
                    "ref": true
                },
                {
                    "text": "Non je ne mourrai pas je vivrai",
                    "ref": true
                },
                {
                    "text": "Je raconterai les œuvres de l’Eternel",
                    "ref": true
                },
                {
                    "text": "Je raconterai les bontés de mon sauveur, je ne mourrai pas yeah",
                    "ref": true
                }
            ]
        },
        {
            "id": 21,
            "title": "Personne comme Jésus",
            "image": "",
            "author": "Shékinah",
            "lyrics": [
                {
                    "text": "Mes amis, je vous assure, j'ai parcouru l'univers\nJ'ai cherché un refuge car je n'avais pas la paix\nDe marabouts en féticheurs, de religion en orbes mystiques\nMais je n'ai rien trouvé (bredouille)\nPuis un merveilleux jour, j'ai rencontré Jésus Christ\nIl a changé ma vie, en lui j'ai trouvé l'amour\nDepuis que je l'ai connu, je peux l'affirmer\nQu'il n'y a personne comme lui",
                    "ref": false
                },
                {
                    "text": "J'ai marché, marché, je n'ai trouvé personne\nJ'ai tourné en rond, oh toujours personne\nJ'ai fouillé, fouillé, fouillé, fouillé, fouillé\nIl n'y a vraiment personne comme lui\nJ'ai marché, marché, marché, personne, personne\nJ'ai tourné en rond, personne, personne\nJ'ai fouillé, fouillé, fouillé, fouillé, fouillé, eh\nIl n'y a vraiment personne comme lui",
                    "ref": false
                },
                {
                    "text": "Il n'y a personne qui soit comme Jésus\nIl n'y a personne qui soit comme Jésus\nIl n'y a personne qui soit comme Jésus\nIl n'y a vraiment personne comme lui",
                    "ref": false
                },
                {
                    "text": "Il n'y a personne qui soit comme Jésus",
                    "ref": true
                },
                {
                    "text": "Non, non il n'y a personne",
                    "ref": false
                },
                {
                    "text": "Il n'y a personne qui soit comme Jésus\nIl n'y a personne qui soit comme Jésus\nIl n'y a vraiment personne comme lui",
                    "ref": true
                },
                {
                    "text": "Oh oui, j'ai longtemps marché",
                    "ref": false
                },
                {
                    "text": "J'ai marché, marché, personne, personne\nJ'ai tourné en rond\nJ'ai tourné en rond, personne, personne",
                    "ref": true
                },
                {
                    "text": "Et j'ai même fouillé",
                    "ref": false
                },
                {
                    "text": "J'ai fouillé, fouillé\nIl n'y a vraiment personne comme lui",
                    "ref": true
                },
                {
                    "text": "J'ai longtemps marché\n(J'ai marché, marché, personne, personne)\nTourné en rond\n(J'ai tourné en rond, personne, personne)\nEt j'ai même fouillé\n(J'ai fouillé, fouillé)\n(Il n'y a vraiment personne comme lui)",
                    "ref": false
                },
                {
                    "text": "Oh, il n'y a personne qui soit comme Jésus. Il n'y a personne qui puisse se comparer à lui. Il n'y a personne qui lui soit semblable sur la Terre, dans le ciel. Il n'y a vraiment personne comme lui,",
                    "ref": false
                },
                {
                    "text": "J'ai marché",
                    "ref": false
                },
                {
                    "text": "J'ai marché, marché, personne, personne .J'ai tourné en rond, personne, personne. J'ai fouillé, fouillé. Il n'y a vraiment personne comme lui",
                    "ref": true
                },
                {
                    "text": "J'ai marché, marché, marché",
                    "ref": false
                },
                {
                    "text": "J'ai marché, marché, personne, personne .J'ai tourné en rond, personne, personne. J'ai fouillé, fouillé. Il n'y a vraiment personne comme lui",
                    "ref": true
                },
                {
                    "text": "Parti de 0. Il m'a rendu héros. C'est pas nor normal. C'est pas nor normal. Il est le way. Il faut juste follow. C'est pas nor normal. C'est pas nor normal",
                    "ref": true
                },
                {
                    "text": "Parti de 0. Il m'a rendu héros. C'est pas nor normal. C'est pas nor normal. Il est le way. Il faut juste follow. C'est pas nor normal. C'est pas nor normal",
                    "ref": true
                }
            ]
        },
        {
            "id": 22,
            "title": "Amazing Grace",
            "image": "",
            "author": "Sarah Brightman",
            "lyrics": [
                {
                    "text": "Amazing Grace, how sweet the sound\nThat saved a wretch like me\nI once was lost but now am found\nWas blind, but now I see\n(BF en sourdine)",
                    "ref": false
                },
                {
                    "text": "T'was Grace that taught my heart to fear\nAnd Grace, my fears relieved\nHow precious did that Grace appear\nThe hour I first believed\n",
                    "ref": false
                },
                {
                    "text": "(Intrumental – guitare acoustique)",
                    "ref": false
                },
                {
                    "text": "Through many dangers, toils and snares\nI have already come\n'Tis Grace that brought me safe thus far\nAnd Grace will lead me home\n(BF en sourdine) ",
                    "ref": false
                },
                {
                    "text": "When we've been here ten thousand years\nBright shining as the sun\nWe've no less days to sing God's praise\nThan when we've first begun\n",
                    "ref": false
                },
                {
                    "text": "Amazing Grace, how sweet the sound\nThat saved a wretch like me\nI once was lost but now am found\nWas blind, but now I see",
                    "ref": true
                }
            ]
        },
        {
            "id": 23,
            "title": "C'est pas normal",
            "image": "",
            "author": "Toofan",
            "lyrics": [
                {
                    "text": "C'est Toofan",
                    "ref": false
                },
                {
                    "text": "Haaaa\nParti de 0\nIl m'a rendu héros\nC'est pas nor normal\nC'est pas nor normal\nIl a le way\nIl faut juste follow\nC'est pas nor normal\nC'est pas nor normal\nBaba God bless me\nOn l'a zoni\nTout ce que je fais\nMais c'est grâce à lui\nEt lo bénis yeu\nOn va faire une petit today\nC'est pas no normal\nSend money\nManger la vie\nIl y'a pas d'soucis\nPetit, haut les mains\nSigner le chèque\nGnama tolémé",
                    "ref": false
                },
                {
                    "text": "Parti de 0\nIl m'a rendu héros\nC'est pas nor normal\nC'est pas nor normal\nIl est le way\nIl faut juste follow\nC'est pas nor normal\nC'est pas nor normal",
                    "ref": true
                },
                {
                    "text": "Ils t'ont lancé cailloux\nTu n'as pas dit non\nIls t'ont craché dessus\nTu n'as pas dit non\nTu as pardonné\nAyiii ta béguiii\nTu as mélangé\nTu as retourné\nC'est béton\nTu as construit maison\nOh oh ooooh\nBaba God ta bénis\nCailloux devient béton\nOh oh ooooh\nBaba God ta bénis\n",
                    "ref": false
                },
                {
                    "text": "Parti de 0\nIl m'a rendu héros\nC'est pas nor normal\nC'est pas nor normal\nIl est le way\nIl faut juste follow\nC'est pas nor normal\nC'est pas nor normal\n\nMouchoir et sifflet\nMouchoir et sifflet\n",
                    "ref": true
                },
                {
                    "text": "Piiii piii\nHé\nPii piriii pi pi\nHé\nPi pi pi\nHé\nPii piriii pi pi\nHé\nPiii piii\nHé\nPii piriii pi pi\nHé\n\nTchi kpo dédji\nMbé douwé dé\nDouwé dé dji\nAdo kakadé\nKakadé dji\nNémawu la woè nawo milaaa\nTchi kpo dédji\nMbé douwé dé\nDouwé dé dji\nAdo kakadé\nKakadé dji\nNémawu la woè nawo milaaa\n… Il est le way\nIl faut juste follow\nC'est pas nor normal\nC'est pas nor normal\n",
                    "ref": true
                }
            ]
        },
        {
            "id": 24,
            "title": "Lean on me",
            "image": "",
            "author": "Bill Withers",
            "lyrics": [
                {
                    "text": "Hmm... hmm-hmm-hmm-hmm\nHmm-hmm-hmm-hmm\nHmm-hmm-hmm-hmm-hmm\n",
                    "ref": false
                },
                {
                    "text": "Sometimes in our lives\nWe all have pain\nWe all have sorrow\nBut if we are wise\nWe know that there's always tomorrow\n",
                    "ref": true
                },
                {
                    "text": "Lean on me\nWhen you're not strong\nAnd I'll be your friend\nI'll help you carry on...\nFor it won't be long\nTill I'm gonna need somebody to lean on\nPlease swallow your pride\nIf I have things you need to borrow\nFor no one can fill\nThose of your needs that you won't let show\n",
                    "ref": false
                },
                {
                    "text": "You just call on me brother when you need a hand",
                    "ref": false
                },
                {
                    "text": "We all need somebody to lean on",
                    "ref": true
                },
                {
                    "text": "I just might have a problem that you'll understand",
                    "ref": false
                },
                {
                    "text": "We all need somebody to lean on",
                    "ref": true
                },
                {
                    "text": "Lean on me\nWhen you're not strong\nAnd I'll be your friend\nI'll help you carry on...\nFor it won't be long\nTill I'm gonna need somebody to lean on\n",
                    "ref": false
                },
                {
                    "text": "You just call on me brother When you need a hand",
                    "ref": false
                },
                {
                    "text": "We all need somebody to lean on",
                    "ref": true
                },
                {
                    "text": "I just might have a problem that you'll understand",
                    "ref": false
                },
                {
                    "text": "We all need somebody to lean on",
                    "ref": true
                },
                {
                    "text": "If there is a load you have to bear\nThat you can't carry\nI'm right up the road\nI'll share your load\nIf you just call me\n",
                    "ref": false
                },
                {
                    "text": "Call me",
                    "ref": true
                },
                {
                    "text": "If you need a friend",
                    "ref": false
                },
                {
                    "text": "Call me",
                    "ref": true
                },
                {
                    "text": "Call me",
                    "ref": false
                },
                {
                    "text": "Call me",
                    "ref": true
                },
                {
                    "text": "If you need a friend",
                    "ref": false
                },
                {
                    "text": "Call me",
                    "ref": true
                },
                {
                    "text": "If you ever need a friend",
                    "ref": false
                },
                {
                    "text": "Call me",
                    "ref": true
                },
                {
                    "text": "Call me",
                    "ref": false
                },
                {
                    "text": "Call me",
                    "ref": true
                },
                {
                    "text": "Call me",
                    "ref": false
                },
                {
                    "text": "Call me",
                    "ref": true
                },
                {
                    "text": "Call me",
                    "ref": false
                },
                {
                    "text": "Call me",
                    "ref": true
                },
                {
                    "text": "if you need a friend",
                    "ref": false
                },
                {
                    "text": "Call me",
                    "ref": true
                },
                {
                    "text": "Call me",
                    "ref": false
                },
                {
                    "text": "Call me",
                    "ref": true
                },
                {
                    "text": "Call me",
                    "ref": false
                },
                {
                    "text": "Call me",
                    "ref": true
                },
                {
                    "text": "Call me",
                    "ref": false
                },
                {
                    "text": "Call me",
                    "ref": true
                },
                {
                    "text": "Call me",
                    "ref": false
                },
                {
                    "text": "Call me",
                    "ref": true
                }
            ]
        },
        {
            "id": 25,
            "title": "Oh Happy Day",
            "image": "",
            "author": "Edwin Hawkins - Anthony Brown w",
            "lyrics": [
                {
                    "text": `Oh happy day
                    Oh happy day
                    Oh happy happy day;
                    Oh happy day
                    When Jesus washed
                    Oh when he washed
                    When Jesus washed
                    He washed my sins away!
                `,
                    "ref": false
                },
                {
                    "text": `Oh happy day
                    Oh happy day
                    Oh happy day
                    Oh happy day
                    When Jesus washed
                    Oh when he washed
                    When Jesus washed
                    He washed my sins away!
                    Oh happy day
                    Oh happy day
                `,
                    "ref": false
                },
                {
                    "text": `He taught me how
                    He taught me
                    Taught me how to watch
                    He taught me how to watch
                    And fight and pray
                    Fight and pray
                    Yes, fight and pray
                `,
                    "ref": true
                },
                {
                    "text": `Oh happy day
                    Oh happy day
                    Oh happy day
                    Oh happy day
                    When Jesus washed
                    Oh when he washed
                    When Jesus washed
                    He washed my sins away!
                    Oh happy day
                    Oh happy day
                `,
                    "ref": false
                },
                {
                    "text": `Oh happy day
                    Oh happy day
                    Oh happy day
                    Oh happy day
                    When Jesus washed
                    Oh when he washed
                    When Jesus washed
                    He washed my sins away!
                    Oh happy day
                    Oh happy day
                `,
                    "ref": false
                },
                {
                    "text": `He taught me how
                    He taught me
                    Taught me how to watch
                    He taught me how to watch
                    And fight and pray
                    Fight and pray
                    Yes, fight and pray
                    And he'll rejoice
                    And He'll, and He'll
                    Rejoice in things we say
                    And He'll rejoicein' things we say
                    Things we say
                    Yes, things we say
                `,
                    "ref": true
                },
                {
                    "text": `Oh happy day`,
                    "ref": false
                },
                {
                    "text": `Oh happy day`,
                    "ref": true
                },
                {
                    "text": `Oh happy day`,
                    "ref": false
                },
                {
                    "text": `Oh happy day`,
                    "ref": true
                },
                {
                    "text": `Oh happy day`,
                    "ref": false
                },
                {
                    "text": `Oh happy day`,
                    "ref": true
                },
                {
                    "text": `Oh happy day`,
                    "ref": false
                },
                {
                    "text": `
                    Oh happy day
                    When Jesus washed
                    Oh when he washed
                    He washed my sins away
                    He taught me how
                    To watch, fight and pray
                    Fight and pray
                    Oh happy day, Oh happy day
                    When Jesus washed
                    Oh when he washed
                    He washed my sins away
                    We'll live rejoicing
                    Ev'ry day, ev'ry day
                    Oh happy day, Oh happy day
                    When Jesus washed
                    Oh when he washed
                    He washed my sins away
                `,
                    "ref": true
                }
            ]
        },
        {
            "id": 26,
            "title": "C'est Dieu",
            "image": "",
            "author": "KS Bloom ft Chidinma",
            "lyrics": [
                {
                    "text": `(allô, allô) Oh-oh-oh, 
                    Allô allô, allô oh-oh-oh
                    Allô allô, allô (oh-oh-oh)
                    Jesus 
                    Eh, to bina un peu d′abord 
                    Avant qu'je raconte mon scénario 
                    C′est vrai que la vie ne fait pas cadeau 
                    Où est papa Noël? Où est son sac à dos? 
                    Et même si problème est dans ma peau 
                    God, God, God noki nako 
                    J'ai décidé de quitter le mal 
                    Car tout ce que je cherchais, c'est lui qui donne 
                    C′est Dieu qui a commencé
                    C′est lui qui va faire un miracle dans la zone
                    C'est Dieu qui a commencé 
                    C′est lui qui ferme la bouche des kpakpatos 
                    C'est Dieu qui a commencé 
                    C′est lui qui va faire un miracle dans la zone 
                    C'est Dieu qui a commencé 
                    C′est lui qui ferme la bouche des kpakpatos
                    Dieu, allô allô Dieu, 
                `,
                    "ref": false
                },
                {
                    "text": `allez allez Dieu, 
                    allô allô allô , eeeg
                    Olayinwola mo ti ri ire Gba oh 
                    Na because you dey my back 
                    Nah why I dey do shakara 
                    You no fit leave me half way oh (I know I know) 
                    Daddy you love me too much oh (I know I know oh oh-oh, I know)
                    C'est Dieu qui a commencé eh-eh-eh 
                    Il a commencé eh-eh-eh 
                    Il a commencé, c'est lui qui va faire un miracle dans ma vie 
                    C′est Dieu qui a commencé 
                    C′est lui qui ferme la bouche de mes ennemis 
                    Dieu, allô allô 
                    oh-oh Dieu, allez allez 
                `,
                    "ref": false
                },
                {
                    "text": `kpa, kpa, kpa, kpa-kpa-kpa`,
                    "ref": true
                },
                {
                    "text": `Allô allô allô eh-eh`,
                    "ref": false
                },
                {
                    "text": `T'as fais de moi une œuvre d′art (allo allo)
                Ne me demande pas de (allez allez) 
                T'as fais de moi une œuvre d′art 
                Ne me demande pas de 
                `,
                    "ref": false
                },
                {
                    "text": `Allô, allô Dieu, 
                Allô allô, Dieu
                Allô allô, Allô eh
                allo, allo, allo, Dieu
                Allô allô, allô eh
                Jesus Oh-oh-oh, oh-oh-oh
                Allô, allô Dieu, 
                Allô allô, Dieu
                Allô allô, Allô eh
                allo, allo, allo, Dieu
                Allô allô, allô eh
                `,
                    "ref": false
                },
                {
                    "text": `Kpa, kpa, kpa, kpa-kpa-kpa`,
                    "ref": true
                },
                {
                    "text": `eh-eh  Oh-oh-oh, oh-oh-oh I don't`,
                    "ref": false
                },
            ]
        },
        {
            "id": 27,
            "title": "Agbaranbe",
            "image": "",
            "author": "version Chorale El-Morijah",
            "lyrics": [
                {
                    "text": `Agbaranbè ninu ejë Jésus 
                Agbaranbè ninu ejë rè
                Agbaranbè ninu ejë Jésus 
                Agbaranbè ninu ejë rè..
                `,
                    "ref": false
                },
                {
                    "text": `Agbaranbè
                Agbaranbè
                Agbaranbè ninu ejè Jésus
                `,
                    "ref": true
                }
            ]
        },
        {
            "id": 28,
            "title": "Imoledeoh",
            "image": "",
            "author": "Free style",
            "lyrics": [
                {
                    "text": `Imolè oôo okukun kparada
                Imolè oôo okukun kparada ooooooo
                Imolè oôo okukun kparada.
                Imolè oôo okukun kparada....`,
                    "ref": false
                },
                {
                    "text": `Imolè oôo okukun kparada
                Imolè oôo okukun kparada ooooooo
                Imolè oôo okukun kparada.
                Imolè oôo okukun kparada....`,
                    "ref": true
                }
            ]
        },
        {
            "id": 29,
            "title": "Il fera",
            "image": "",
            "author": "",
            "lyrics": [
                {
                    "text": `Infiniment, abondamment
                Bien au-delà de tout ce que tu demandes 
                Au travers de la puissance qui agit en toi
                Dieu est capable de faire, tout ce qu’Il dit, Il fera 
                Il accomplira, toutes ses promesses envers toi 
                Garde ta foi en Dieu, Il ne t’abandonnera pas, Il fera.`,
                    "ref": false
                },
                {
                    "text": `Infiniment, abondamment
                Bien au-delà de tout ce que tu demandes 
                Au travers de la puissance qui agit en toi
                Dieu est capable de faire, tout ce qu’Il dit, Il fera 
                Il accomplira, toutes ses promesses envers toi 
                Garde ta foi en Dieu, Il ne t’abandonnera pas, Il fera.`,
                    "ref": true
                }
            ]
        },
        {
            "id": 30,
            "title": "Sa miséricorde",
            "image": "",
            "author": "Shekinah",
            "lyrics": [
                {
                    "text": `Louez l’Eternel car Il est bon 
                Louez le Seigneur des Seigneurs`,
                    "ref": false
                },
                {
                    "text": `sa miséricorde dure à toujours`,
                    "ref": true
                },
                {
                    "text": `Lorsque nous tombons, il est là pour nous relever`,
                    "ref": false
                },
                {
                    "text": `sa miséricorde dure à toujours aye`,
                    "ref": true
                },
                {
                    "text": `Quand nous sommes attaqués, sa main nous secoure et nous délivre`,
                    "ref": false
                },
                {
                    "text": `sa miséricorde dure à toujours`,
                    "ref": true
                },
                {
                    "text": `Ses promesses se renouvellent pour nous chaque matin `,
                    "ref": false
                },
                {
                    "text": `sa miséricorde dure à toujours aye`,
                    "ref": true
                },
                {
                    "text": `Je célèbre ton nom, à cause de ta bonté et de ta fidélité `,
                    "ref": false
                },
                {
                    "text": `sa miséricorde dure à toujours`,
                    "ref": true
                },
                {
                    "text": `Alléluia 
                Sachez que l’éternel est Dieu et il est bon`,
                    "ref": false
                },
                {
                    "text": `sa miséricorde dure à toujours aye`,
                    "ref": true
                },
                {
                    "text": `Nous sommes la prunelle des yeux de l’éternel`,
                    "ref": false
                },
                {
                    "text": `sa miséricorde dure à toujours`,
                    "ref": true
                },
                {
                    "text": `Si Dieu est pour nous, qui sera contre nous `,
                    "ref": false
                },
                {
                    "text": `Dieu est bon, Il est bon, Dieu est bon.`,
                    "ref": true
                },
                {
                    "text": `Célébrez-le, Bénissez son nom, proclamez ses bienfaits,
                Chantez ses louanges, car Dieu est bon et sa bonté dure à toujours
                `,
                    "ref": false
                },
                {
                    "text": `Dieu est bon, Il est bon, Dieu est bon.`,
                    "ref": true
                },
                {
                    "text": `Sachez que l’Eternel est Dieu, il est le roi il est bon
                Sachez que l’Eternel est Dieu, il est le roi il est bon
                Sachez que l’Eternel est Dieu, il est le roi il est bon
                Sachez que l’Eternel est Dieu, il est le roi il est bon
                Il nous a donné Jésus
                `,
                    "ref": false
                },
                {
                    "text": `il est bon`,
                    "ref": true
                },
                {
                    "text": `Il nous a donné Jésus le salut `,
                    "ref": false
                },
                {
                    "text": `il est bon`,
                    "ref": true
                },
                {
                    "text": `Il nous a donné sa protection`,
                    "ref": false
                },
                {
                    "text": `il est bon`,
                    "ref": true
                },
                {
                    "text": `Il nous a donné sa bénédiction`,
                    "ref": false
                },
                {
                    "text": `il est bon`,
                    "ref": true
                },
                {
                    "text": `Il nous a donné la foi `,
                    "ref": false
                },
                {
                    "text": `il est bon`,
                    "ref": true
                },
                {
                    "text": `Il nous a donné l’espoir `,
                    "ref": false
                },
                {
                    "text": `il est bon`,
                    "ref": true
                },
                {
                    "text": `Il nous a donné la victoire `,
                    "ref": false
                },
                {
                    "text": `il est bon`,
                    "ref": true
                },
                {
                    "text": `Il nous a donné la joie `,
                    "ref": false
                },
                {
                    "text": `il est bon`,
                    "ref": true
                },
                {
                    "text": "Quand j’étais tombée, Il m’a relevée ",
                    "ref": true
                },
                {
                    "text": "il est bon",
                    "ref": false
                },
                {
                    "text": "Quand j’étais malade, il m’a guérie ",
                    "ref": true
                },
                {
                    "text": "il est bon",
                    "ref": false
                },
                {
                    "text": "Attaquée il m’a délivrée ",
                    "ref": true
                },
                {
                    "text": "il est bon",
                    "ref": false
                },
                {
                    "text": "Abattue il m’a consolée ",
                    "ref": true
                },
                {
                    "text": "il est bon",
                    "ref": false
                },
                {
                    "text": "Humiliée il m’a relevée ",
                    "ref": true
                },
                {
                    "text": "il est bon",
                    "ref": false
                },
                {
                    "text": "Je ne cesserai de chanter son nom eh ",
                    "ref": true
                },
                {
                    "text": "il est bon",
                    "ref": false
                },
                {
                    "text": "Il m’a fait la grâce de parler de lui eh ",
                    "ref": true
                },
                {
                    "text": "il est bon",
                    "ref": false
                },
                {
                    "text": "Il m’a fait la grâce de chanter son nom eh ",
                    "ref": true
                },
                {
                    "text": "il est bon",
                    "ref": false
                },
                {
                    "text": "Voyez, voyez, comme il est bon ",
                    "ref": true
                },
                {
                    "text": "il est bon",
                    "ref": false
                },
                {
                    "text": "Voyez, voyez, comme il est bon eh ",
                    "ref": true
                },
                {
                    "text": "il est bon",
                    "ref": false
                },
                {
                    "text": "Mes frères élevons-le car il est bon ",
                    "ref": true
                },
                {
                    "text": "il est bon",
                    "ref": false
                },
                {
                    "text": "Mes frères psalmodions-le car il est bon ",
                    "ref": true
                },
                {
                    "text": "il est bon",
                    "ref": false
                },
                {
                    "text": "Mes frères psalmodions-le car il est bon eh ",
                    "ref": true
                },
                {
                    "text": "il est bon",
                    "ref": false
                },
                {
                    "text": "Oh dansons pour lui car il est bon eh ",
                    "ref": true
                },
                {
                    "text": "il est bon",
                    "ref": false
                },
                {
                    "text": "Venez louer chanter danser célébrer son nom ",
                    "ref": true
                },
                {
                    "text": "il est bon",
                    "ref": false
                },
                {
                    "text": "Acclamer son nom, glorifier son nom ",
                    "ref": true
                },
                {
                    "text": "il est bon",
                    "ref": false
                },
                {
                    "text": "Il est bon, Il est bon, Il est bon ",
                    "ref": false
                },
                {
                    "text": "il est bon",
                    "ref": true
                },
                {
                    "text": "Il est bon, Il est bon, Il est bon ",
                    "ref": false
                },
                {
                    "text": "il est bon",
                    "ref": true
                },
                {
                    "text": "Il est bon, Il est bon, Il est bon ",
                    "ref": false
                },
                {
                    "text": "il est bon",
                    "ref": true
                },
                {
                    "text": "Il est bon, Il est bon, Il est bon eeh ",
                    "ref": false
                },
                {
                    "text": "il est bon",
                    "ref": true
                },
                {
                    "text": "Il est bon, Il est bon, Il est bon eeh ",
                    "ref": false
                },
                {
                    "text": "il est bon",
                    "ref": true
                },
                {
                    "text": "Pour sa paix, pour ses grands faits, pour ses hauts faits ",
                    "ref": false
                },
                {
                    "text": "il est bon",
                    "ref": true
                },
                {
                    "text": "Pour sa joie, pour nos voix, pour sa voix ",
                    "ref": false
                },
                {
                    "text": "il est bon",
                    "ref": true
                },
                {
                    "text": "Pour sa fidélité, pour sa sainteté ",
                    "ref": false
                },
                {
                    "text": "il est bon",
                    "ref": true
                },
                {
                    "text": "Pour sa vie, son amour qui dure a toujours ",
                    "ref": false
                },
                {
                    "text": "il est bon",
                    "ref": true
                },
                {
                    "text": "Yahveh ton nom est merveilleux ",
                    "ref": false
                },
                {
                    "text": "tu m’as tout donné",
                    "ref": true
                },
                {
                    "text": "El Shadaï ton nom est merveilleux ",
                    "ref": false
                },
                {
                    "text": "tu m’as tout donné",
                    "ref": true
                },
                {
                    "text": "Adonaï ton nom est merveilleux eh ",
                    "ref": false
                },
                {
                    "text": "tu m’as tout donné",
                    "ref": true
                },
                {
                    "text": "Mon Dieu ton nom est merveilleux ",
                    "ref": false
                },
                {
                    "text": "tu m’as tout donné",
                    "ref": true
                },
                {
                    "text": "Tu m’as donné la joie que je cherchais ",
                    "ref": false
                },
                {
                    "text": "tu m’as tout donné",
                    "ref": true
                },
                {
                    "text": "Tu m’as donné le bonheur que je cherchais ",
                    "ref": false
                },
                {
                    "text": "tu m’as tout donné",
                    "ref": true
                },
                {
                    "text": "Tu m’as donné le mari que je cherchais ",
                    "ref": false
                },
                {
                    "text": "tu m’as tout donné",
                    "ref": true
                },
                {
                    "text": "Tu m’as donné les enfants que je cherchais ",
                    "ref": false
                },
                {
                    "text": "tu m’as tout donné",
                    "ref": true
                },
                {
                    "text": "Tu m’as donné le travail que j’ai tant cherché ",
                    "ref": false
                },
                {
                    "text": "tu m’as tout donné",
                    "ref": true
                },
                {
                    "text": "Ce que l’homme n’a pu faire ",
                    "ref": false
                },
                {
                    "text": "il l’a fait pour moi",
                    "ref": true
                },
                {
                    "text": "Ce que l’homme n’a pu faire ",
                    "ref": false
                },
                {
                    "text": "il l’a fait pour moi",
                    "ref": true
                },
                {
                    "text": "Tout ce que ma force n’a pu faire ",
                    "ref": false
                },
                {
                    "text": "il l’a fait pour moi",
                    "ref": true
                },
                {
                    "text": "Ce que ma sagesse n’a pu faire ",
                    "ref": false
                },
                {
                    "text": "il l’a fait pour moi",
                    "ref": true
                },
                {
                    "text": "Ce que mes relations n’ont pu faire ",
                    "ref": false
                },
                {
                    "text": "il l’a fait pour moi",
                    "ref": true
                },
                {
                    "text": "Ce que l’argent n’a pu faire ",
                    "ref": false
                },
                {
                    "text": "il l’a fait pour moi",
                    "ref": true
                },
                {
                    "text": "Il l’a fait pour moi ",
                    "ref": false
                },
                {
                    "text": "il l’a fait pour moi",
                    "ref": true
                },
                {
                    "text": "Il l’a fait pour moi eeh ",
                    "ref": false
                },
                {
                    "text": "il l’a fait pour moi",
                    "ref": true
                },
                {
                    "text": "Le salut est réservé à tous les enfants de Dieu",
                    "ref": false
                },
                {
                    "text": "Le salut est réservé à tous les enfants de Dieu, Louez…",
                    "ref": false
                },
                {
                    "text": "louez, louez, louez, louez, louez, louez, louez, louez, hosanna",
                    "ref": true
                },
                {
                    "text": "La victoire est à nous Dieu nous l’a donné par son fils",
                    "ref": false
                },
                {
                    "text": "Dans son amour il nous a réconcilié avec lui, oui louez, louez, louez",
                    "ref": false
                },
                {
                    "text": "louez, louez, louez, louez, louez, louez, louez, louez, hosanna",
                    "ref": true
                },
                {
                    "text": "De notre père oui nous avons le succès",
                    "ref": false
                },
                {
                    "text": "le succès est réservé à tous les enfants de Dieu, le succès est réservé à tous les enfants de Dieu",
                    "ref": true
                },
                {
                    "text": "Il faut le louer ",
                    "ref": false
                },
                {
                    "text": "louez, louez, louez, louez, louez, louez, louez, louez, hosanna",
                    "ref": true
                },
                {
                    "text": "louez, louez, louez, louez, louez, louez, louez, louez, hosanna",
                    "ref": true
                },
                {
                    "text": "Il faut le louer, louer, louer, louer oui je veux le louer",
                    "ref": false
                },
                {
                    "text": "Louez………………. ",
                    "ref": false
                },
                {
                    "text": "louez, louez, louez, louez, louez, louez, louez, louez, hosanna",
                    "ref": true
                },
                {
                    "text": "louez, louez, louez, louez, louez, louez, louez, louez, hosanna",
                    "ref": true
                },
                {
                    "text": "louez, louez, louez, louez, louez, louez, louez, louez, hosanna",
                    "ref": true
                },
                {
                    "text": "louez Dieu, louez Dieu, louez Dieu, ",
                    "ref": true
                },
                {
                    "text": "la bible dit de lui qu’il n’a pas regardé son égalité avec Dieu",
                    "ref": false
                },
                {
                    "text": "(chœur : la la la la laaaaa)",
                    "ref": true
                },
                {
                    "text": "Comme une proie à arracher mais il s’est dépouillé lui-même En prenant forme de serviteur, se rendant semblable aux hommes, il s’est humilie lui-même, se rendant obéissant jusqu’à la mort, la mort de la croix,",
                    "ref": false
                },
                {
                    "text": "(chœur : la la la la laaaaa)",
                    "ref": true
                },
                {
                    "text": "C’est pourquoi, alleluia, Dieu l’a souverainement eleve, et il lui a donne le nom qui est au-dessus de tout nom",
                    "ref": false
                },
                {
                    "text": "(chœur : adorons leeeee)",
                    "ref": true
                },
                {
                    "text": "Et qu’au nom de Jésus, tout genou fléchisse dans les cieux et sur la terre, que toute langue confesse que Jésus-Christ est seigneur dans les cieux et sur la terre",
                    "ref": false
                },
                {
                    "text": "(chœur : adorons leeeee)",
                    "ref": true
                },
                {
                    "text": "A la gloire de Dieu le père",
                    "ref": false
                },
                {
                    "text": `Jésus, Il est le Seigneur
                    Adorons Jésus, Il est le Seigneur, Amen
                    Adorons Jésus, Il est le Seigneur
                    Adorons Jésus, Il est le Seigneur, Amen
                `,
                    "ref": true
                },
                {
                    "text": `Il a reçu le Nom au-dessus de tout nom
                    Jésus a reçu le Nom au-dessus de tout nom
                    Et tout genou fléchira lorsqu’on parlera de l’agneau
                    Et tout genou fléchira lorsqu’on parlera de l’agneau eeeh
                `,
                    "ref": false
                },
                {
                    "text": `Adorons Jésus, Il est le Seigneur
                    Adorons Jésus, Il est le Seigneur, Amen
                    Il a reçu le Nom au-dessus de tout nom
                    Il a reçu le Nom qui surpasse tout autre nom
                    Tout genou fléchira lorsqu’on parlera de l’agneau
                    Toute langue confessera que Jésus a vaincu le tombeau
                `,
                    "ref": true
                },
                {
                    "text": `Adorons Jésus, Il est le Seigneur
                    Adorons Jésus, Il est le Seigneur, Amen
                `,
                    "ref": true
                },
                {
                    "text": "Il a donne le pouvoir de marcher sur les démons",
                    "ref": false
                },
                {
                    "text": "Il a donne la puissance pour guérir en son nom",
                    "ref": false
                },
                {
                    "text": "Et tout esprit qui ne confesse pas son nom sera banni",
                    "ref": false
                },
                {
                    "text": "Tout malade qui croit en Jésus Christ sera guéri eeh",
                    "ref": false
                },
                {
                    "text": "Par sa puissance, adorons-le",
                    "ref": false
                },
                {
                    "text": "Adorons Jésus, Il est le Seigneur",
                    "ref": true
                },
                {
                    "text": "Adorons Jésus, Il est le Seigneur, Amen",
                    "ref": true
                },
                {
                    "text": "Adorons Jésus, Il est le Seigneur",
                    "ref": true
                },
                {
                    "text": "Adorons Jésus, Il est le Seigneur, Amen",
                    "ref": true
                },
                {
                    "text": `Louons Jesus-Christ de Nazareth eeh
                    Le premier patron de Shekinah, le lion de Juda, 
                    l’agneau de Dieu qui ôte le péché du monde, la rose de saron, 
                    le lys des vallees, l’admirable conseiller eeh, 
                    l’etoile brillante du matin, le soleil de justice, 
                    celui qui ferme et personne ne peut ouvrir, 
                    c’est lui qui ouvre et personne ne peut fermer eeh… 
                    Alleluia eh !
                `,
                    "ref": false
                },
                {
                    "text": "Tout le monde debout, levez les mains et glorifiez le nom de Jésus",
                    "ref": false
                },
                {
                    "text": "Tout le monde debout, balancez les mains et glorifiez le nom de Jésus",
                    "ref": false
                },
                {
                    "text": "Tout le monde debout, levez les mains et glorifiez le nom de Jésus",
                    "ref": false
                },
                {
                    "text": "Tout le monde debout, balancez les mains et glorifiez le nom de Jésus",
                    "ref": false
                },
                {
                    "text": "Ce que je veux c’est louer mon Jésus",
                    "ref": false
                },
                {
                    "text": "Ce que je veux c’est louer mon Jésus",
                    "ref": false
                },
                {
                    "text": "Ce que je veux c’est louer mon Jésus",
                    "ref": false
                },
                {
                    "text": "Ce que je veux c’est louer mon Jésus",
                    "ref": false
                },
                {
                    "text": "Oh je veux louer, je veux louer eh",
                    "ref": false
                },
                {
                    "text": "je veux louer, je veux louer eh",
                    "ref": false
                },
                {
                    "text": "Je veux chanter eh, louer son nom",
                    "ref": false
                },
                {
                    "text": "Ce que je veux c’est louer mon Jésus",
                    "ref": false
                },
                {
                    "text": "Il a payé pour que je sois sauvée",
                    "ref": false
                },
                {
                    "text": "Voila pourquoi je veux le célébrer eh",
                    "ref": false
                },
                {
                    "text": "Ooh je veux louer son nom",
                    "ref": false
                },
                {
                    "text": "Oui je veux louer eh, je veux louer eh",
                    "ref": false
                },
                {
                    "text": "Je veux louer son nom, je veux chanter son nom",
                    "ref": false
                },
                {
                    "text": "Je veux le célébrer, oui pour tous ses bienfaits",
                    "ref": false
                },
                {
                    "text": "Car il m’a sauvée, il m’a délivrée",
                    "ref": false
                },
                {
                    "text": "Moi je veux le louer, je veux le danser",
                    "ref": false
                },
                {
                    "text": "je veux danser pour lui, je veux crier son nom",
                    "ref": false
                },
                {
                    "text": "je veux louer, je veux louer",
                    "ref": true
                },
                {
                    "text": "je veux louer, je veux louer",
                    "ref": true
                },
                {
                    "text": "je veux louer, je veux louer",
                    "ref": true
                },
                {
                    "text": `je veux louer, je veux louer
                je veux louer, je veux louer`,
                    "ref": false
                },
                {
                    "text": `Tout le monde louez, louez, louez, louez, louez, louez eeh
                    Tout le monde louez, tout le monde louez,
                    Moi je veux louer
                    Faut faire comme moi, viens on va louer Jesus-Christ
                    Je veux louer
                `,
                    "ref": false
                },
                {
                    "text": "ayayayy Jésus est bon ehehe",
                    "ref": false
                },
                {
                    "text": "il est bon",
                    "ref": true
                },
                {
                    "text": "Oui le fils de Dieu est bon eh",
                    "ref": false
                },
                {
                    "text": "il est bon",
                    "ref": true
                },
                {
                    "text": "Oh mon sauveur est bon eh",
                    "ref": false
                },
                {
                    "text": "il est bon",
                    "ref": true
                },
                {
                    "text": "Oui mon rédempteur est bon eh",
                    "ref": false
                },
                {
                    "text": "il est bon",
                    "ref": true
                },
                {
                    "text": "Oui mon sauveur il est bon eh",
                    "ref": false
                },
                {
                    "text": "il est bon",
                    "ref": true
                },
                {
                    "text": "Il m’a sauvé il est bon eh",
                    "ref": false
                },
                {
                    "text": "il est bon",
                    "ref": true
                },
                {
                    "text": "Il m’a racheté il est bon eh",
                    "ref": false
                },
                {
                    "text": "il est bon",
                    "ref": true
                },
                {
                    "text": "Il m’a délivré il est bon eh",
                    "ref": false
                },
                {
                    "text": "il est bon",
                    "ref": true
                },
                {
                    "text": "oh mon sauveur est bon eh",
                    "ref": false
                },
                {
                    "text": "il est bon",
                    "ref": true
                },
                {
                    "text": "oh ayayaye",
                    "ref": false
                },
                {
                    "text": "ayayaye",
                    "ref": true
                },
                {
                    "text": "ayayaye yayaieh",
                    "ref": false
                },
                {
                    "text": "ayayaye",
                    "ref": true
                },
                {
                    "text": "ayayaye yayaye yayaieeh",
                    "ref": false
                },
                {
                    "text": "yayayaieeh il est bon yayeeh",
                    "ref": true
                },
                {
                    "text": "Oh Ayaye il est bon aeh",
                    "ref": false
                },
                {
                    "text": "Oh ayayaye eeh",
                    "ref": false
                },
                {
                    "text": "oh ayayaye Jesus est bon eh",
                    "ref": true
                },
                {
                    "text": "Mes frères il est bon eh",
                    "ref": false
                },
                {
                    "text": "J’ai goute Jesus il est bon eh",
                    "ref": false
                },
                {
                    "text": "il est bon",
                    "ref": true
                },
                {
                    "text": "Je realise aujourd’hui qu’il est bon eh ",
                    "ref": true
                },
                {
                    "text": "Je chante ayayaye eeh ",
                    "ref": true
                },
                {
                    "text": "Ayayaye yayaye ieeh ",
                    "ref": true
                },
                {
                    "text": "ayayayayayaye******** ",
                    "ref": true
                },
                {
                    "text": "Oh Emmanuel est bon eh ",
                    "ref": true
                },
                {
                    "text": "il est l’Etoile brillante du matin ",
                    "ref": true
                },
                {
                    "text": "le soleil de justice l’admirable conseiller ",
                    "ref": true
                },
                {
                    "text": "le lion de la tribu de juda ",
                    "ref": true
                },
                {
                    "text": "ayayayayayaye******** ",
                    "ref": true
                },
                {
                    "text": "il est bon(x3) eeeh",
                    "ref": true
                },
                {
                    "text": "Yeba ! Envoie ta puissance sur nous Oh Esprit de Dieu, consume en nous le peche et purifie nos ames ",
                    "ref": false
                },
                {
                    "text": "Mets en nous ta flamme et ton sel et baptise-nous de feu",
                    "ref": false
                },
                {
                    "text": "Le feu est allumé aujourd’hui",
                    "ref": false
                },
                {
                    "text": "Le feu est allumé aujourd’hui,",
                    "ref": false
                },
                {
                    "text": "Le feu est allumé aujourd’hui,",
                    "ref": false
                },
                {
                    "text": "Chantons alléluia, le feu est allumé",
                    "ref": false
                },
                {
                    "text": "Chantons alléluia, le feu est allumé",
                    "ref": false
                },
                {
                    "text": "Le feu est allumé aujourd’hui",
                    "ref": false
                },
                {
                    "text": "Le feu est allumé aujourd’hui",
                    "ref": false
                },
                {
                    "text": "Le feu est allumé aujourd’hui",
                    "ref": false
                },
                {
                    "text": "Chantons alléluia, le feu est allumé",
                    "ref": false
                },
                {
                    "text": "Chantons alléluia, le feu est allumé",
                    "ref": false
                },
                {
                    "text": "Que ton feu Seigneur ",
                    "ref": false
                },
                {
                    "text": "brûle en moi",
                    "ref": true
                },
                {
                    "text": "Que ton feu Seigneur ",
                    "ref": false
                },
                {
                    "text": "brûle en moi",
                    "ref": true
                },
                {
                    "text": `brûle en moi, brûle en moi
                    Brûle en moi, brûle en moi
                    Brûle en moi, brûle en moi
                    Brûle en moi, brûle en moi
                `,
                    "ref": true
                },
                {
                    "text": `Brûle en moi, brûle en moi
                    Brûle en moi, brûle en moi
                    Brûle en moi, brûle en moi
                    Brûle en moi, brûle en moi
                `,
                    "ref": false
                },
                {
                    "text": `Le feu est allumé aujourd’hui
                    Le Saint-Esprit descend dans sa gloire
                    Et sa puissance fait parler de lui
                    Par son œuvre efficace nous avons la foi
                    Et aujourd’hui sa gloire nous voulons voir
                `,
                    "ref": false
                },
                {
                    "text": `Le feu est allumé aujourd’hui 
                    Allumé et cela pour toujours
                    Le Saint-Esprit est descendu ce jour
                    Chantons alléluia le feu est allumé
                    Chantons alléluia le feu est allumé 
                `,
                    "ref": true
                },
                {
                    "text": "Que ton feu Seigneur",
                    "ref": false
                },
                {
                    "text": "brûle en moi",
                    "ref": true
                },
                {
                    "text": "Que ton feu Seigneur",
                    "ref": false
                },
                {
                    "text": "brûle en moi",
                    "ref": false
                },
                {
                    "text": `Brûle en moi, brûle en moi
                    Brûle en moi, brûle en moi
                    Brûle en moi, brûle en moi
                `,
                    "ref": true
                },
                {
                    "text": "Brule oh, brule oh",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Brule en moi ehe, brule en moi ehe",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Brule en moi ehe, brule en moi ehe",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Brûle en moi, brûle en moi",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Brule en moi, brule en moi",
                    "ref": false
                },
                {
                    "text": "brule en moi, brule en moi",
                    "ref": true
                },
                {
                    "text": "Que ton feu Seigneur, brule en moi",
                    "ref": false
                },
                {
                    "text": "brûle en moi",
                    "ref": true
                },
                {
                    "text": "Que ton feu Seigneur, brule en moi",
                    "ref": false
                },
                {
                    "text": "brûle en moi",
                    "ref": true
                },
                {
                    "text": `brûle en moi, brûle en moi
                    brûle en moi, brûle en moi
                    brûle en moi, brûle en moi
                    brûle en moi, brûle en moi
                    brûle en moi, brûle en moi
                    brûle en moi, brûle en moi
                    brûle en moi, brûle en moi
                    brûle en moi, brûle en moi
                `,
                    "ref": true
                },
                {
                    "text": "Brûle…. Dans ma tête oh",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Dans mon cœur oh ",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Dans mes pieds oh ",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Dans mon ame ooh ",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Dans mon pays oh ",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Dans nos foyers ooh ",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Dans Shekinah eeh ",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Mon ministère ooh ",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Brule oh… Brule oooh… brule oooh brule oooh ",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Eeeeeeee…. Brule en moi ee, brule en moi eeh, ",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Brule en moi eeh, brule en moi eeh ",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Fais descendre ta puissance ",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Fais descendre ta grâce ",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Fais descendre ton esprit ",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Fais descendre ta faveur ",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Fais descendre ta flamme ",
                    "ref": false
                },
                {
                    "text": "brûle en moi, brûle en moi",
                    "ref": true
                },
                {
                    "text": "Attention eeeeh, Attention eeeeh, ",
                    "ref": false
                },
                {
                    "text": "La gloire de Dieu est descendue eeeh ",
                    "ref": false
                },
                {
                    "text": "L’onction divine est descendue eeeh",
                    "ref": false
                },
                {
                    "text": "Recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez recevez, recevez, recevez, recevez",
                    "ref": true
                },
                {
                    "text": "Attention eeeeh, Attention eeeeh",
                    "ref": false
                },
                {
                    "text": "La protection divine est descendue eh",
                    "ref": false
                },
                {
                    "text": "La faveur de Dieu est arrivee oh",
                    "ref": false
                },
                {
                    "text": "Recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez",
                    "ref": true
                },
                {
                    "text": "Attention eh, Attention eh",
                    "ref": false
                },
                {
                    "text": "Tout le monde en position de recevoir oh",
                    "ref": false
                },
                {
                    "text": "Bonne nouvelle pour tous les célibataires oh",
                    "ref": false
                },
                {
                    "text": "La faveur de Dieu pour ton mariage est descendue eeh",
                    "ref": false
                },
                {
                    "text": "Recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez",
                    "ref": true
                },
                {
                    "text": "Attention eh, Attention eh",
                    "ref": false
                },
                {
                    "text": "La prospérité divine est descendue eh",
                    "ref": false
                },
                {
                    "text": "La richesse divine est arrivée oh",
                    "ref": false
                },
                {
                    "text": "Recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez",
                    "ref": true
                },
                {
                    "text": `Attention eh, Attention eh
                    Bonne nouvelle pour tous les malades oh
                    La guérison divine est descendue vers toi mon frère eh
                `,
                    "ref": false
                },
                {
                    "text": "Recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez",
                    "ref": true
                },
                {
                    "text": `Attention eh, Attention eh
                    Bonne nouvelle pour les élèves et puis les étudiants eh
                    L’intelligence divine est descendue eh
                    La sagesse de Dieu est arrivée oh
                `,
                    "ref": false
                },
                {
                    "text": "Recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez, recevez",
                    "ref": true
                }

            ]
        },
        {
            "id": 31,
            "title": "Vovome",
            "image": "",
            "author": "Bethel choir revival",
            "lyrics": [
                {
                    "text": `Matso nye gbe adzi ha
                    Matso nye dzi akafui
                    Matso nye nuse awo do na mawu Yesiayi
                    Fofo Mawue, Ve Nunye
                    Nye Xoname, Xonam dzro
                    Matso nye nuse awo do na mawu Yesiayi
                    Fofo Mawue, Ve Nunye
                    Gbo gbo kokoi, Xonam dzro
                    Matso nye nuse awo do na mawu Yesiayi
                    Alevi si wo wu la
                    Mi Kafui
                    Mi kafui, Haleluya
                    Mi doe de dzi, Hosiana
                    Mi kafui, Haleluya
                    Mi Kafui
                    Alevi si wo wu la
                    Mi Kafui
                    Vovo le Vovo me (Vovo le Vovo me)
                    Vovo le Vovo me (Vovo le Vovo me)
                    Vovo le Vovo me (Vovo le Vovo me)
                    Dela Yesu, towo menye
                    Ewom mezu ablodevi
                    Egblo nam be tanyee newo anyigba la do
                    Ma zo azoli, ma wo ako de edzi
                    Vovo me
                    Vovo le vovo me, Vovo le vovo me
                    Vovo le vovo me, Vovo le vovo me
                    Dela Yesu, towo menye
                    Ewom mezu ablodevi
                    Egblo nam be tanyee newo anyigba la do
                    Ma zo azoli, ma wo ako de edzi
                    Vovo me
                    Ma zo azoli, ma wo ako de edzi
                    Vovo me
                    Ma wo ako de edzi
                    Vovo me
                    Vovo le vovo me, Vovo le vovo me
                    Dzo adesi nye Mawu do de menye
                    Ma tuido, ma tsi oo
                    Agbemavo dzoe
                    Mawu lolo nto
                    Mida akpe
                `,
                    "ref": false
                }
            ]
        },
    ]
}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}